import React, { useEffect, useRef, useState,useCallback} from 'react';
import Swal from 'sweetalert2';
import axios from 'axios';
import ReactDOM from 'react-dom';
import AsyncSelect from 'react-select/async';
import Modalforaneosprint from './Modalforaneosprint';
import { MdLocalShipping, MdCancel, MdFactCheck, MdInventory, MdAccessTime } from 'react-icons/md';
import { FaBoxOpen, FaPrint, FaPeopleCarry, FaPlus } from 'react-icons/fa';
import _ from 'lodash';
import { Icon } from 'react-materialize';

const styles = {
  modalBackground: {
    position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.7)', zIndex: 9999,
    overflowY: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center'
  },
  modalContainer: {
    backgroundColor: 'white', borderRadius: '10px', width: '100%',
    maxWidth: '100%', maxHeight: '100%', height: '100%',
    overflowY: 'auto', padding: '20px', position: 'relative'
  },
  closeButton: {
    position: 'absolute', top: '10px', right: '20px',
    backgroundColor: '#f44336', color: '#fff', border: 'none',
    fontSize: '0.9rem', padding: '6px 10px', borderRadius: '5px',
    cursor: 'pointer', zIndex: 10000
  },
  modalTitle: {
    fontSize: '1.4rem', fontWeight: 'bold',
    marginBottom: '20px', textAlign: 'center'
  },
  modalCard: {
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    padding: '12px 16px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
    fontSize: '0.9rem',
    marginBottom: '16px',
    width: '24%'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: '20px'
  },
  nameCheckin: { fontWeight: 'bold', fontSize: '1rem' },
  turnCheckin: { color: '#555', fontSize: '0.95rem' },
  statusCheckin: { color: '#888', marginBottom: '6px', fontSize: '0.85rem' },
  separator: { borderBottom: '1px solid #ccc', margin: '8px 0' },
  button: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    gap: '6px', backgroundColor: '#00796B', color: '#fff', border: 'none',
    padding: '6px 10px', borderRadius: '4px', cursor: 'pointer', width: '100%',
    fontSize: '0.85rem'
  },
  printButton: {
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    gap: '6px', backgroundColor: '#2196F3', color: '#fff', border: 'none',
    padding: '6px 10px', borderRadius: '4px', cursor: 'pointer',
    width: '100%', marginTop: '6px', fontSize: '0.85rem'
  }
};

const pillBase = {
  marginTop: 6,
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  padding: '6px 10px',
  borderRadius: 8,
  fontWeight: 600
};

const getErpGroup = (order) => Array.isArray(order?.erp_group_list)
  ? order.erp_group_list
  : String(order?.erp_group_csv || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

const ConsolidatedViewer = ({ order }) => {
  const group = getErpGroup(order);
  return (
    <div style={{ marginTop: 6 }}>
      <div style={{ fontSize: 12, color: '#666' }}>
        consolidados / agregados  ({group.length})
      </div>

      {group.length > 0 && (
        <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginTop:4 }}>
          {group.map((erp) => (
            <span
              key={erp}
              style={{
                background:'#E3F2FD',
                color:'#0D47A1',
                border:'1px solid #90CAF9',
                borderRadius:999,
                padding:'2px 8px',
                fontSize:12,
                lineHeight:1.6,
                display:'inline-flex',
                alignItems:'center',
                gap:6
              }}
              title={`ERP consolidado ${erp}`}
            >
              {erp}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

const PILL_THEMES = {
  surtidor:   { bg: '#FFF8E1', border: '#FFE082' },
  empacador:  { bg: '#EDE7F6', border: '#D1C4E9' },
  paqueteria: { bg: '#E3F2FD', border: '#90CAF9' },
  vendedor:   { bg: '#E8F5E9', border: '#A5D6A7' },
};

const InfoPill = ({ emoji, title, value, type = 'surtidor' }) => {
  const theme = PILL_THEMES[type] || PILL_THEMES.surtidor;
  return (
    <div style={{ ...pillBase, background: theme.bg, border: `1px solid ${theme.border}` }}>
      <span>{emoji} <strong>{title}:</strong></span>
      <span>{value || 'No disponible'}</span>
    </div>
  );
};

const SurtidorPill = ({ name }) => (
  <InfoPill emoji="🧑‍🏭" title="Surtidor" value={name} type="surtidor" />
);

const forceSwalZindex = () => {
  setTimeout(() => {
    const popup = document.querySelector('.swal2-popup');
    const container = document.querySelector('.swal2-container');
    if (popup) {
      popup.style.zIndex = '11000';
      popup.style.position = 'fixed';
      popup.style.top = '50%';
      popup.style.left = '50%';
      popup.style.transform = 'translate(-50%, -50%)';
    }
    if (container) {
      container.style.zIndex = '11000';
      container.style.position = 'fixed';
      container.style.top = '0';
      container.style.left = '0';
      container.style.width = '100vw';
      container.style.height = '100vh';
    }
  }, 5);
};

const ONE_DAY_MS = 24 * 60 * 60 * 1000;
const ONE_HOUR_MS = 60 * 60 * 1000;
const isPendingOverDay = (o, nowMsArg = Date.now()) => {
  const st = String(o?.status || '').toLowerCase();
  if (st === 'entregado' || st === 'cancelado') return false;
  const startISO = o?.created_at;
  if (!startISO) return false;
  const startMs = new Date(startISO).getTime();
  return (nowMsArg - startMs) >= ONE_DAY_MS;
};

const pendingPillStyle = {
  position: 'absolute',
  top: 30,
  left: 8,
  background: '#FFEBEE',
  color: '#B71C1C',
  border: '1px solid #EF9A9A',
  borderRadius: 6,
  padding: '2px 6px',
  fontWeight: 900,
  fontSize: 'clamp(10px, 0.85vw, 12px)',
  lineHeight: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  height: 20
};

const CUT_OFF_SALTILLO_MIN  = 16 * 60 + 30; 
const CUT_OFF_DOMICILIO_MIN = 16 * 60;      
const CUT_OFF_OTHERS_MIN    = 15 * 60;      

const _getDateSafe = (v) => {
  if (!v) return null;
  const d = new Date(v);
  return isNaN(+d) ? null : d;
};

function _getFacturadoAt(order) {
  const candidates = [
    order?.facturado_at,
    order?.invoiced_at,
    order?.invoice_at,
    order?.invoice_created_at,
    order?.invoice_date,
    order?.invoiceDate,
    order?.invoice_ts,
    order?.status_facturado_at,
    (String(order?.status || '').toLowerCase() === 'facturado'
      ? order?.last_status_change_at
      : null),
  ];
  for (const c of candidates) {
    const d = _getDateSafe(c);
    if (d) return d;
  }
  return null;
}

function computeFacturaFueraDeHorario(order) {
  const facturadoAt = _getFacturadoAt(order);
  if (!facturadoAt) return { show: false };

  const carrierRaw  = String(order?.carrier ?? '').trim().toLowerCase();
  const isSaltillo  = carrierRaw === 'saltillo';
  const isDomicilio = carrierRaw === 'domicilio';

  let cutoffMin;
  let cutoffText;

  if (isSaltillo) {
    cutoffMin  = CUT_OFF_SALTILLO_MIN;  
    cutoffText = '16:30';
  } else if (isDomicilio) {
    cutoffMin  = CUT_OFF_DOMICILIO_MIN; 
    cutoffText = '16:00';
  } else {
    cutoffMin  = CUT_OFF_OTHERS_MIN;    
    cutoffText = '15:00';
  }

  const mins = facturadoAt.getHours() * 60 + facturadoAt.getMinutes();
  const outsideSchedule = mins > cutoffMin; 

  const timeText = new Intl.DateTimeFormat('es-MX', {
    timeZone: 'America/Mexico_City',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).format(facturadoAt);

  return {
    show: true,
    timeText,
    cutoffText,
    isSaltillo,
    isDomicilio,
    outsideSchedule,
  };
}

const FacturaFueraHorarioBadge = ({ order }) => {
  const { show, timeText, cutoffText, isSaltillo, isDomicilio, outsideSchedule } =
    computeFacturaFueraDeHorario(order);

  if (!show) return null; 

  let scope = 'Otras paqueterías';
  if (isSaltillo) scope = 'Saltillo';
  else if (isDomicilio) scope = 'Domicilio';
  const bg     = outsideSchedule ? '#FFEBEE' : '#E8F5E9';
  const border = outsideSchedule ? '#EF9A9A' : '#A5D6A7';
  const color  = outsideSchedule ? '#C62828' : '#1B5E20';
  const label  = outsideSchedule
    ? 'Factura fuera de horario'
    : 'Facturado en horario';

  return (
    <div
      className="label-table"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        marginTop: 4,
        padding: '4px 8px',
        background: bg,
        color,
        borderRadius: 6,
        fontSize: 12,
        fontWeight: 600,
        border: `1px solid ${border}`,
      }}
      title={`Facturado a las ${timeText} (límite ${cutoffText} — ${scope})`}
    >
      <span aria-hidden="true">🕒</span>
      <span>
        {label} — {scope}: {timeText}
      </span>
    </div>
  );
};

const EntregadosColumn = React.memo(function EntregadosColumn({
  orders = [],
  isDeliveredToday,
  ymdTZ,
  renderEntregadoCard,
}) {
  const todayYMD = ymdTZ(Date.now());

  const [viewMode, setViewMode] = React.useState('today');
  const [selectedDate, setSelectedDate] = React.useState(todayYMD);
  const [selectedMonth, setSelectedMonth] = React.useState(todayYMD.slice(0, 7));

  const deliveredTs = (o) => o?.delivered_at || o?.last_status_change_at || o?.updated_at;

  const monthLabel = (ym) => {
    if (!ym) return '';
    const [y, m] = ym.split('-').map(Number);
    return new Date(y, m - 1, 1).toLocaleDateString('es-MX', { month: 'long', year: 'numeric' });
  };

  const dayPretty = (ymd) => {
    if (!ymd) return '';
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString('es-MX', {
      weekday: 'long', day: '2-digit', month: 'long', year: 'numeric'
    });
  };

  const filtered = React.useMemo(() => {
    if (!Array.isArray(orders)) return [];
    switch (viewMode) {
      case 'today':
        return orders.filter(isDeliveredToday);
      case 'day':
        return orders.filter(o => ymdTZ(deliveredTs(o)) === selectedDate);
      case 'month':
        return orders.filter(o => {
          const ymd = ymdTZ(deliveredTs(o));
          return ymd && ymd.slice(0, 7) === selectedMonth;
        });
      default:
        return orders;
    }
  }, [orders, viewMode, selectedDate, selectedMonth, isDeliveredToday, ymdTZ]);


  const headerSuffix =
    viewMode === 'today' ? 'Hoy'
    : viewMode === 'day' ? dayPretty(selectedDate)
    : monthLabel(selectedMonth);

  return (
    <div>
      <h4 style={{ marginBottom: 12 }}>
        Entregados — <span style={{ fontWeight: 700, textTransform: 'capitalize' }}>{headerSuffix}</span>
      </h4>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 12 }}>
        <div style={{ display: 'inline-flex', gap: 8 }}>
          <button
            onClick={() => setViewMode('today')}
            style={{ padding:'8px 10px', borderRadius:6, border:'1px solid #ccc',
                     background:viewMode==='today' ? '#E8F5E9' : '#fff', fontWeight:700, cursor:'pointer' }}>
            Hoy
          </button>
          <button
            onClick={() => setViewMode('day')}
            style={{ padding:'8px 10px', borderRadius:6, border:'1px solid #ccc',
                     background:viewMode==='day' ? '#E3F2FD' : '#fff', fontWeight:700, cursor:'pointer' }}>
            Día
          </button>
          <button
            onClick={() => setViewMode('month')}
            style={{ padding:'8px 10px', borderRadius:6, border:'1px solid #ccc',
                     background:viewMode==='month' ? '#FFF3E0' : '#fff', fontWeight:700, cursor:'pointer' }}>
            Mes
          </button>
        </div>

        {viewMode === 'day' && (
          <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)}
                 style={{ padding: 8, border: '1px solid #ccc', borderRadius: 6 }} />
        )}

        {viewMode === 'month' && (
          <input type="month" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}
                 style={{ padding: 8, border: '1px solid #ccc', borderRadius: 6 }} />
        )}
      </div>

      <div style={{ display:'flex', flexWrap:'wrap', gap:15, justifyContent:'flex-start' }}>
        {filtered.map((order, index) => renderEntregadoCard(order, index))}
        {filtered.length === 0 && (
          <p style={{ color:'#888', fontStyle:'italic', marginTop:6 }}>
            Sin entregados en el periodo seleccionado.
          </p>
        )}
      </div>
    </div>
  );
});
const ZONES_LIST = [
  { zone: 'VNAH', label: 'Foráneos',  color: '#00796B', icon: '🏷️' },
  { zone: 'VDEP', label: 'Saltillo',  color: '#F57C00', icon: '🏠' },
  { zone: 'VIDD', label: 'Domicilio', color: '#9C27B0', icon: '🏠' },
  { zone: 'VYIS', label: 'Cliente_pasa',     color: '#7B1FA2', icon: '🏬' },
];


const ModalForaneos = ({ open, onClose, user, catalog, Button }) => {
  const [orders, setOrders] = useState([]);

  const isMounted = useRef(false);
  const [selectedAgents, setSelectedAgents] = useState({});
  const [printOpen, setPrintOpen] = useState(false);
  const [printData, setPrintData] = useState(null);
  const [facturandoId, setFacturandoId] = useState(null);
  const isCajera = user?.departmentId === '004';
  const isGerente = user?.departmentId === '001' || user?.departmentId === '002';
  const isAsesorTele = user?.departmentId === '003' || user?.departmentId === '005' || user?.departmentId === '006';
  const isAlmacen = user?.departmentId === '007';
  const isAlmacen2 = user?.agent === 'almacen2';
  const [onlyDomicilio, setOnlyDomicilio] = useState(false);
  const norm = useCallback((s) => {
    return (s ?? '').toString().trim().toLowerCase();
  }, []);

  const isCarrierDomicilio = (o) => norm(o?.carrier) === 'domicilio';
  const [viewingAlmacen, setViewingAlmacen] = useState(false);
  const isSoloVista = isGerente || isAsesorTele;

  const statusToFetch = React.useMemo(() => {
    const wantAlmacenStatuses = ['facturado', 'surtiendo', 'surtido', 'empacando', 'enviado', 'entregado'];
    const wantCajaStatuses    = ['aplicando pago'];
  
    if (((isGerente || isAsesorTele) && viewingAlmacen) || isAlmacen) return wantAlmacenStatuses;
    if (isCajera || ((isGerente || isAsesorTele) && !viewingAlmacen)) return wantCajaStatuses;
  
    return [];
  }, [isGerente, isAsesorTele, viewingAlmacen, isAlmacen, isCajera]);
        const [searchQuery, setSearchQuery] = useState('');
  const [visibleStatus, setVisibleStatus] = useState(null);
  const [visibleZone, setVisibleZone] = useState(null);
  const [activeStatusButton, setActiveStatusButton] = useState('facturado');
  const [activeZoneButton, setActiveZoneButton] = useState('VNAH');
const [activeCarrierButton, setActiveCarrierButton] = useState(null);
const [visibleCarrier, setVisibleCarrier] = useState(null);
const getOrdersForBucket = (bucket) => {
  const baseRaw = (isAlmacen || viewingAlmacen)
    ? (orders || [])
    : Object.values(orders || {}).flat();
  const base = (isAlmacen && !isAlmacen2)
    ? baseRaw.filter(o => onlyDomicilio ? isCarrierDomicilio(o) : !isCarrierDomicilio(o))
    : baseRaw;

  const want = (bucket || '').toLowerCase().trim();

  if (want === 'surtido-despachador') {
    return base
      .filter(o => norm(o.status) === 'surtido' && !hasDespachador(o))
      .filter(matchesSearch);
  }
  if (want === 'surtido') {
    return base
      .filter(o => norm(o.status) === 'surtido' && hasDespachador(o))
      .filter(matchesSearch);
  }
  if (want === 'entregado') {
    return base
      .filter(isDeliveredToday)
      .filter(matchesSearch);
  }
  if (want === 'empacando' && onlyDomicilio) {
    return base
      .filter(o =>
        norm(o.status) === 'empacando' ||
        (norm(o.status) === 'surtido' && hasDespachador(o) && isCarrierDomicilio(o))
      )
      .filter(matchesSearch);
  }

  return base
    .filter(o => norm(o.status) === want)
    .filter(matchesSearch);
};

const carrierNorm = (s) => (s || '').toString().trim().toLowerCase();

                                                                  
const [editAgentMode, setEditAgentMode] = useState({}); 
const [editSelected, setEditSelected] = useState({});   
const [, setAgentOverrides] = useState({});
const _editKey = (orderId, role) => `${orderId}:${role}`;
const isEditing = (orderId, role) => !!(editAgentMode[orderId]?.[role]);

const startEdit = (order, role, presetLabel, presetValue) => {
  setEditAgentMode(prev => ({ 
    ...prev, 
    [order.id]: { ...(prev[order.id] || {}), [role]: true } 
  }));
  const key = _editKey(order.id, role);
  const current = editSelected[key] || {
    label: presetLabel || '',
    value: presetValue || '',
    code:  presetValue || ''
  };
  setEditSelected(prev => ({ ...prev, [key]: current }));
};

const cancelEdit = (orderId, role) => {
  setEditAgentMode(prev => {
    const copy = { ...(prev[orderId] || {}) };
    delete copy[role];
    return { ...prev, [orderId]: copy };
  });
  const key = _editKey(orderId, role);
  setEditSelected(prev => {
    const { [key]: _omit, ...rest } = prev;
    return rest;
  });
};

const saveEditSurtidor = async (order) => {
  const key = _editKey(order.id, 'surtidor');
  const selected = editSelected[key];
  if (!selected) return Swal.fire('Selecciona un surtidor', '', 'info');
  setAgentOverrides(prev => ({
    ...prev,
    [order.id]: {
      ...(prev[order.id] || {}),
      surtidor_id: selected.value ?? selected.code,
      surtidor_name: selected.label ?? ''
    }
  }));
  cancelEdit(order.id, 'surtidor');

  try {
    await axios.put(`/api/foraneos/${order.id}/assign-surtidor`, {
      surtidor_id: selected.value ?? selected.code,
      surtidor_name: selected.label ?? ''
    });
    await toastOk('Surtidor asignado');
    fetchRemoteOrders(); 
  } catch (err) {
    console.error(err);
    Swal.fire('Error', 'No se pudo actualizar el surtidor.', 'error');
    setAgentOverrides(prev => {
      const copy = { ...(prev[order.id] || {}) };
      delete copy.surtidor_id; delete copy.surtidor_name;
      const rest = { ...prev, [order.id]: copy };
      if (!Object.keys(copy).length) delete rest[order.id];
      return rest;
    });
  }
};

const saveEditDespachador = async (order) => {
  const key = _editKey(order.id, 'despachador');
  const selected = editSelected[key];
  if (!selected) return Swal.fire('Selecciona un despachador', '', 'info');

  setAgentOverrides(prev => ({
    ...prev,
    [order.id]: {
      ...(prev[order.id] || {}),
      despachador_id: selected.value ?? selected.code,
      despachador_name: selected.label ?? ''
    }
  }));
  cancelEdit(order.id, 'despachador');

  try {
    await axios.put(`/api/foraneos/assign-despachador/${order.id}`, {
      despachador_id: selected.value ?? selected.code,
      despachador_name: selected.label ?? ''
    });
    await toastOk('Despachador asignado');
    fetchRemoteOrders();
  } catch (err) {
    console.error(err);
    Swal.fire('Error', 'No se pudo actualizar el despachador.', 'error');
    setAgentOverrides(prev => {
      const copy = { ...(prev[order.id] || {}) };
      delete copy.despachador_id; delete copy.despachador_name;
      const rest = { ...prev, [order.id]: copy };
      if (!Object.keys(copy).length) delete rest[order.id];
      return rest;
    });
  }
};

const saveEditEmpacador = async (order) => {
  const key = _editKey(order.id, 'empacador');
  const selected = editSelected[key];
  if (!selected) return Swal.fire('Selecciona un empacador', '', 'info');

  setAgentOverrides(prev => ({
    ...prev,
    [order.id]: {
      ...(prev[order.id] || {}),
      packed_by: selected.value ?? selected.code,
      packed_by_name: selected.label ?? ''
    }
  }));
  cancelEdit(order.id, 'empacador');

  try {
    await axios.put(`/api/foraneos/${order.id}/pack`, {
      agentId: selected.value ?? selected.code,
      agentName: selected.label ?? ''
    });
    await toastOk('Empacador asignado');
    fetchRemoteOrders();
  } catch (err) {
    console.error(err);
    Swal.fire('Error', 'No se pudo actualizar el empacador.', 'error');
    setAgentOverrides(prev => {
      const copy = { ...(prev[order.id] || {}) };
      delete copy.packed_by; delete copy.packed_by_name;
      const rest = { ...prev, [order.id]: copy };
      if (!Object.keys(copy).length) delete rest[order.id];
      return rest;
    });
  }
};

const toastOk = async (msg = 'Cambios guardados') => {
  await Swal.fire({
    icon: 'success',
    title: msg,
    timer: 1100,
    showConfirmButton: false,
    timerProgressBar: true,
    position: 'top',
    backdrop: false,
  });
};

const ZONES_META = {
  VNAH: { label: 'Foráneos',  cashier: 'Cajera: Nallely' },
  VDEP: { label: 'Saltillo',  cashier: 'Cajera: Devany perez' },
  VIDD: { label: 'Domicilio', cashier: 'Cajera: ' },
  VYIS: { label: 'Cliente-pasa',     cashier: 'Cajera: ' },
};


const TZ = 'America/Mexico_City';

const getUserSite = (user) => {
  const raw =
    user?.site ||
    user?.pickup_branch ||
    user?.branch ||
    user?.store ||
    user?.sucursal ||
    '';

  const s = String(raw).trim();
  const m = s.match(/\b(3000|3100)\b/);
  return m ? m[1] : s; 
};


const getOrderSite = (o) => {
  const raw =
    o?.site ||
    o?.pickup_branch ||
    o?.pickupBranch ||
    o?.branch ||
    o?.store ||
    o?.sucursal ||
    '';

  const s = String(raw).trim();
  const m = s.match(/\b(3000|3100)\b/);
  return m ? m[1] : (s === '3000' || s === '3100' ? s : '');
};

const SITE_META = {
  '3000': { label: 'MTY · 3000', bg: '#E8F5E9', border: '#A5D6A7', color: '#1B5E20' },
  '3100': { label: 'CDMX · 3100', bg: '#E3F2FD', border: '#90CAF9', color: '#0D47A1' },
};

const SiteChip = ({ order }) => {
  const site = getOrderSite(order);
  const meta = SITE_META[site] || { label: 'SITE · —', bg:'#F5F5F5', border:'#E0E0E0', color:'#616161' };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: 999,
        background: meta.bg,
        border: `1px solid ${meta.border}`,
        color: meta.color,
        fontWeight: 900,
        fontSize: '0.75rem',
        lineHeight: 1,
      }}
      title={`Sucursal / site: ${site || 'sin dato'}`}
    >
      {meta.label}
    </span>
  );
};


const userSite = React.useMemo(() => getUserSite(user), [user]);

const isCDMX = userSite === '3100';

const isCDMXCajera = isCajera && isCDMX;

const allowedZones = React.useMemo(() => {
  if (isCDMXCajera) return [ 'VYIS'];
  return ['VNAH', 'VDEP', 'VIDD', 'VYIS'];
}, [isCDMXCajera]);

const visibleZones = React.useMemo(
  () => ZONES_LIST.filter(z => allowedZones.includes(z.zone)),
  [allowedZones]/** */
);


const zoneByCarrier = useCallback((o) => {
  const c = norm(o?.carrier);
  
  
  if (c === 'saltillo') return 'VDEP';
  if (c === 'domicilio') return 'VIDD';
  
 
  if (c === 'cliente_pasa' || 
      c === 'cliente-pasa' || 
      c === 'cliente pasa' || 
      c === 'cliente_pasa' ||
      c === 'cliente-pasa' ||
   (c.includes('cliente') && c.includes('pasa'))) {
    return 'VYIS';
  }
  
  
  return 'VNAH';
}, [norm]);
  
const fetchRemoteOrders = useCallback(async () => {
  try {
    const { data: allOrders } = await axios.get('/api/foraneos');

    let filtered = (allOrders || []).filter(o => {
      const st = norm(o?.status);
      return st && st !== 'cancelado' && statusToFetch.includes(st);
    });

    const isCajasView =
      (isCajera || ((isGerente || isAsesorTele) && !viewingAlmacen));

    if (isCajasView && userSite && !isGerente) {
      filtered = filtered.filter(
        o => String(o?.pickup_branch || '').trim() === userSite
      );
    }

    if ((isGerente || isAsesorTele) && viewingAlmacen) {
      if (isMounted.current) setOrders(filtered);
      return;
    }

    if (isAlmacen || isAlmacen2) {
      if (isMounted.current) setOrders(filtered);
      return;
    }

    const grouped = { VNAH: [], VDEP: [], VIDD: [], VYIS: [] };

    filtered.forEach((o) => {
      const isOwnTurno = norm(o.created_by) === norm(user?.username);
      const canSee =
        isGerente || isCajera || (isAsesorTele && isOwnTurno);

      if (!canSee) return;

      const z = zoneByCarrier(o);
      (grouped[z] ?? grouped.VNAH).push(o);
    });

    if (isCDMXCajera) {
      grouped.VNAH = [];
      grouped.VDEP = [];
    }

    if (isMounted.current) setOrders(grouped);
  } catch (err) {
    console.error('[REMOTE_ORDERS_ERROR]', err);
    Swal.fire('Error', 'No se pudieron cargar los pedidos foráneos', 'error');
  }
}, [
  statusToFetch,
  isCajera,
  isGerente,
  isAsesorTele,
  viewingAlmacen,
  userSite,
  isAlmacen,
  isAlmacen2,
  isCDMXCajera,
  user,norm,
  zoneByCarrier
]);
      
const hasDespachador = (o) =>
  !!(o?.despachador_id || (o?.despachador_name && String(o.despachador_name).trim() !== '') || (o?.dispatcher_name && String(o.dispatcher_name).trim() !== ''));

const matchesSearch = (order) => {
  const q = searchQuery.trim().toLowerCase();
  if (!q) return true; 

  const cliente = String(order.customer_name || '').toLowerCase();
  const erp     = String(order.erp_order_id || '').toLowerCase();
  const carrier = String(order.carrier || '').toLowerCase();

  return (
    cliente.includes(q) ||
    erp.includes(q) ||
    carrier.includes(q)
  );
};

const applyCarrierFilter = (list) => {
  const arr = Array.isArray(list) ? list : [];
  if (!visibleCarrier) return arr;
  return arr.filter(o => carrierNorm(o?.carrier) === carrierNorm(visibleCarrier));
};

const getOrdersForBucketCarrier = (status) => applyCarrierFilter(getOrdersForBucket(status));

const isAlmacenView =
  (isAlmacen && !isAlmacen2) ||
  ((isGerente || isAsesorTele) && viewingAlmacen);

const carrierBuckets = onlyDomicilio
  ? ['facturado', 'surtiendo', 'surtido-despachador', 'empacando', 'enviado']
  : ['facturado', 'surtiendo', 'surtido-despachador', 'surtido', 'empacando', 'enviado'];

const carrierCountBase = !isAlmacenView
  ? []
  : (() => {
      const seen = new Set();
      const out = [];

      for (const b of carrierBuckets) {
        const list = getOrdersForBucket(b) || [];
        for (const o of list) {
          const key =
            String(o?.id ?? '') ||
            `${String(o?.erp_order_id ?? '')}|${String(o?.created_at ?? '')}`;

          if (!key) continue;
          if (seen.has(key)) continue;
          seen.add(key);
          out.push(o);
        }
      }
      return out;
    })();

const getCarrierCount = (carrier) => {
  if (!carrier) return carrierCountBase.length; 
  const c = carrierNorm(carrier);
  return carrierCountBase.filter(o => carrierNorm(o?.carrier) === c).length;
};

const carriersForAlmacen = (() => {
  const uniq = Array.from(
    new Set(carrierCountBase.map(o => (o?.carrier || '').toString().trim()).filter(Boolean))
  );
  uniq.sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));
  return uniq;
})();

  const ymdTZ = (dateLike) => {
    try {
      const d = new Date(dateLike);
      const parts = new Intl.DateTimeFormat('es-MX', {
        timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(d);
      const y = parts.find(p => p.type === 'year')?.value;
      const m = parts.find(p => p.type === 'month')?.value;
      const dd = parts.find(p => p.type === 'day')?.value;
      return `${y}-${m}-${dd}`;
    } catch {
      return null;
    }
  };

  const todayYMD = ymdTZ(Date.now());

  const isPendiente = (order) => {
    if (!order?.created_at) return false;
    const day = ymdTZ(order.created_at);
    const st = String(order?.status || '').toLowerCase();
    return !!day && !!todayYMD && day < todayYMD && st !== 'entregado' && st !== 'cancelado';
  };

  const compareByPendienteThenDate = (a, b) => {
    const A = isPendiente(a), B = isPendiente(b);
    if (A !== B) return A ? -1 : 1;
    return new Date(a.created_at) - new Date(b.created_at);
  };


const renderGuideButtons = (order) => {
  const guiaExiste = String(order.guia || '').trim() !== '';

  const commonBtn = {
    padding: '6px 12px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  };

  const out = [];

  if (guiaExiste) {
    out.push(
      <span key="ok" style={{ color: 'green', fontWeight: 'bold' }}>
        <span role="img" aria-label="exito">✅</span> Guía guardada
      </span>
    );
    if (!isSoloVista) {
      out.push(
        <button
          key="edit"
          onClick={() => editGuides(order)}
          style={{ ...commonBtn, backgroundColor: '#388e3c', color: '#fff' }}
          title="Editar guías"
        >
          Editar guía
        </button>
      );
    }
  } else {
    if (!isSoloVista) {
      out.push(
        <button
          key="add"
          onClick={() => agregarGuia(order, fetchRemoteOrders)}
          style={{ ...commonBtn, backgroundColor: '#388e3c', color: '#fff' }}
          title="Agregar una o varias guías"
        >
          <FaPlus /> Agregar Guía
        </button>
      );
    }
  }

  out.push(
    <button
      key="view"
      onClick={() => showGuides(order.guia, order)}
      style={{ ...commonBtn, backgroundColor: '#ffffff', color: '#333', border: '1px solid #ccc' }}
      title="Ver guías"
    >
      Ver guías
    </button>
  );

  return out;
};


  const turnoMap = React.useMemo(() => {
    const list = (isCajera || ((isGerente || isAsesorTele) && !viewingAlmacen))
      ? Object.values(orders || {}).flat()
      : (isAlmacen ? (orders || []) : []);

    const valid = (list || [])
      .filter(o => o && o.created_at && String(o.status).toLowerCase() !== 'cancelado')
      .filter(() => true)
      .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

    const counters = new Map();
    const out = {};
    for (const o of valid) {
      const day = ymdTZ(o.created_at);
      if (!day) continue;
      const next = (counters.get(day) || 0) + 1;
      counters.set(day, next);
      out[o.id] = next;
    }
    return out;
  }, [orders, isCajera, isGerente, isAsesorTele, viewingAlmacen, isAlmacen]);

  const getTurnoDia = (order) => turnoMap?.[order?.id] ?? '—';

  const PendienteChip = () => (
    <span style={{
      display:'inline-flex', alignItems:'center',
      padding:'2px 8px', marginRight:8,
      borderRadius: 999, background:'#FFF3E0',
      border:'1px solid #FFB74D', color:'#E65100',
      fontWeight:800, fontSize:'0.75rem', lineHeight:1
    }}>
      PENDIENTE
    </span>
  );

  const TurnoHeader = ({ order, elapsed, color, textColor = '#fff' }) => {
    const pend = isPendiente(order);
    return (
      <div style={{ position:'absolute', top:8, right:8, textAlign:'right' }}>
        {isGerente && (
          <div style={{ marginBottom: 6, display:'flex', justifyContent:'flex-end' }}>
            <SiteChip order={order} />
          </div>
        )}
  
        <div
          className={`turno-badge ${pend ? 'pend' : ''}`}
          style={{
            backgroundColor: color, color: textColor,
            padding:'6px 10px', borderRadius:'14px',
            fontSize:'1rem', fontWeight:'bold',
            display:'inline-flex', alignItems:'center'
          }}
        >
          {pend && <PendienteChip />}
          <span>Turno {getTurnoDia(order)}</span>
        </div>
  
        <div style={{
          display:'flex', alignItems:'center', justifyContent:'flex-end',
          color:'#333', fontSize:'1rem', fontWeight:'bold', marginTop:4
        }}>
          <Icon className="darker" style={{ marginRight:6, fontSize:'1.2rem' }}>timer</Icon>{elapsed}
        </div>
      </div>
    );
  };
    

  
  const isToday = (ts) => !!ts && ymdTZ(ts) === todayYMD;

  
  const isDeliveredToday = (o) =>
    String(o?.status || '').toLowerCase() === 'entregado' &&
    isToday(o?.delivered_at || o?.last_status_change_at || o?.updated_at);


  const AutoPaginator = ({ items = [], pageSize = 6, interval = 10000, renderItem }) => {
    const [page, setPage] = useState(0);

    useEffect(() => {
      if (!items.length) return;
      const totalPages = Math.ceil(items.length / pageSize);
      if (page >= totalPages) setPage(0);

      const id = setInterval(() => {
        setPage(prev => (prev + 1) % Math.ceil(items.length / pageSize));
      }, interval);

      return () => clearInterval(id);
    }, [items, pageSize, interval, page]);

    const start = page * pageSize;
    const visible = items.slice(start, start + pageSize);

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {visible.map((item, idx) => (
          <div key={item.id || item.erp_order_id || `${start}-${idx}`}>
            {renderItem(item)}
          </div>
        ))}
      </div>
    );
  };

  const handleAssignDespachador = async (order) => {
    const selected = selectedAgents[order.id];
    if (!selected) {
      return Swal.fire({
        title: 'Selecciona un despachador',
        icon: 'info',
        confirmButtonText: 'OK',
        onOpen: forceSwalZindex
      });
    }
  
    try {
      const confirm = await Swal.fire({
        title: '¿Confirmar despachador?',
        html: `<strong>Cliente:</strong> ${order.customer_name}<br/>
               <strong>Pedido:</strong> ${order.erp_order_id}<br/>
               <strong>Despachador:</strong> ${selected.label}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, confirmar',
        cancelButtonText: 'Cancelar',
        onOpen: forceSwalZindex
      });
      if (!confirm.isConfirmed) return;
  
      
      await axios.put(`/api/foraneos/assign-despachador/${order.id}`, {
        despachador_id: selected.value ?? selected.code,
        despachador_name: selected.label ?? ''
      });
  
    
      if (isCarrierDomicilio(order)) {
        try {
          await axios.put(`/api/foraneos/${order.id}/pack`, {
            agentId: selected.value ?? selected.code,
            agentName: selected.label ?? ''
          });
        } catch (packErr) {
          console.error('[AUTO_PACK_DOMICILIO_ERROR]', packErr);
  
        }
      }
  
      await Swal.fire({
        title: isCarrierDomicilio(order)
          ? 'Despachador asignado y pedido empacado'
          : 'Despachador asignado',
        text: isCarrierDomicilio(order)
          ? 'El pedido avanzó directamente a EMPACADO.'
          : 'Se guardó el despachador para este pedido.',
        icon: 'success',
        onOpen: forceSwalZindex
      });
  
      fetchRemoteOrders();
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'No se pudo asignar despachador.', 'error');
    }
  };
      
  const handleMarkSurtido = async (order) => {
    try {
      const confirm = await Swal.fire({
        title: '¿Marcar como SURTIDO?',
        html: `<strong>Cliente:</strong> ${order.customer_name || 'Sin cliente'}<br/><strong>Pedido:</strong> ${order.erp_order_id || 'Sin número'}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, marcar',
        cancelButtonText: 'No',
        onOpen: forceSwalZindex,
      });
      if (!confirm.isConfirmed) return;

      await axios.put(`/api/foraneos/${order.id}/status`, { newStatus: 'surtido' });

      await Swal.fire({
        title: 'Listo',
        text: 'El pedido fue marcado como SURTIDO.',
        icon: 'success',
        onOpen: forceSwalZindex,
      });

      fetchRemoteOrders();
    } catch (err) {
      console.error(err);
      Swal.fire({ title: 'Error', text: 'No se pudo marcar como SURTIDO.', icon: 'error', onOpen: forceSwalZindex });
    }
  };

  const [nowTick, setNowTick] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNowTick(Date.now()), 30000);
    return () => clearInterval(t);
  }, []);

  const agregarGuia = (order, fetchRemoteOrders) => {
    Swal.fire({
      title: `Agregar guía al pedido ${order.erp_order_id}`,
      html: `<strong>Cliente:</strong> ${order.customer_name}`,
      input: 'textarea',
      inputLabel: 'Ingresa una o varias guías (una por línea)',
      inputPlaceholder: 'Ejemplo:\n123456789\n987654321',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      onOpen: () => {
        forceSwalZindex();
      },
      preConfirm: (guia) => {
        return axios
          .put(`/api/foraneos/${order.id}/guia`, { guia })
          .then((res) => {
            if (!res.data.success) throw new Error(res.data.message);
            return true;
          })
          .catch((err) => {
            Swal.showValidationMessage(`Error: ${err.message}`);
          });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire('¡Éxito!', 'La(s) guía(s) se guardaron correctamente.', 'success');
        if (typeof fetchRemoteOrders === 'function') {
          fetchRemoteOrders();
        }
      }
    });
  };



  const canUseModal = isCajera || isAlmacen || isAlmacen2 || isGerente || isAsesorTele;

  useEffect(() => {
    isMounted.current = true;
    if (!user || !open || !canUseModal) return;
    fetchRemoteOrders();
    return () => { isMounted.current = false; };
  }, [open, user, canUseModal, viewingAlmacen, fetchRemoteOrders]);

  useEffect(() => {
    if (!open) return;
    const first = allowedZones[0] || null;
    setActiveZoneButton(first);
    setVisibleZone(first);
  }, [open, allowedZones]);
  
  
  useEffect(() => {
    if (!user || !open || !canUseModal) return;
  
    const POLL_MS = isAlmacen2 ? 15000 : 120000;
    const id = setInterval(() => {
      if (isMounted.current) fetchRemoteOrders();
    }, POLL_MS);
  
    return () => clearInterval(id);
  }, [user, open, canUseModal, isAlmacen2, viewingAlmacen, fetchRemoteOrders]);

    const timeSince = (timestamp) => {
    if (!timestamp) return '—';
    const now = new Date();
    const changed = new Date(timestamp);
    const diffMs = now - changed;

    const minutes = Math.floor(diffMs / 60000);
    if (minutes < 1) return '0 min';
    if (minutes < 60) return `${minutes} min`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hr ${minutes % 60} min`;

    const days = Math.floor(hours / 24);
    return `${days} día(s)`;
  };

  const editMainERP = async (order) => {
    try {
      const { value, isConfirmed } = await Swal.fire({
        title: 'INGRESAR PC',
        input: 'text',
        inputValue: order.erp_order_id || '',
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
        onOpen: forceSwalZindex,
      });

      if (!isConfirmed || !value) return;

      await axios.put(`/api/foraneos/${order.id}/erp`, {
        erp_order_id: String(value).trim().toUpperCase(),
      });

      await Swal.fire({
        title: 'Actualizado',
        text: 'ERP principal cambiado.',
        icon: 'success',
        onOpen: forceSwalZindex,
      });

      fetchRemoteOrders();
    } catch (e) {
      await Swal.fire({
        title: 'Error',
        text: 'No se pudo actualizar el ERP principal',
        icon: 'error',
        onOpen: forceSwalZindex,
      });
    }
  };

  const handleReturnToAdvisor = async (order) => {
    const { value: reason, isConfirmed } = await Swal.fire({
      title: 'Regresar a asesor',
      input: 'textarea',
      inputLabel: 'Motivo (qué hay que corregir)',
      inputPlaceholder: 'Ej: Comprobante no coincide con el total...',
      inputAttributes: { 'aria-label': 'Motivo' },
      showCancelButton: true,
      confirmButtonText: 'Regresar',
      cancelButtonText: 'Cancelar',
      onOpen: forceSwalZindex
    });

    if (!isConfirmed) return;

    try {
      await axios.put(`/api/foraneos/${order.id}/status`, {
        newStatus: 'aplicando pago',
        return_to_advisor: true,
        return_reason: String(reason || '').trim() || 'Sin motivo'
      });

      await Swal.fire({
        title: 'Turno devuelto',
        text: 'El turno fue regresado al asesor con tu comentario.',
        icon: 'success',
        onOpen: forceSwalZindex
      });

      fetchRemoteOrders();
    } catch (err) {
      console.error('[RETURN_TO_ADVISOR_ERROR]', err);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo regresar el turno al asesor.',
        icon: 'error',
        onOpen: forceSwalZindex
      });
    }
  };

  const handleNextStepCajera = async (order) => {
    const nextStatus = getNextStatus(order.status);
    if (!nextStatus) return;
  
    // Detectar si es Cliente_pasa
    const isClientePasa = 
      String(order.carrier || '').toLowerCase().includes('cliente') &&
      String(order.carrier || '').toLowerCase().includes('pasa');
    
    const isPickup = isClientePasa || 
      String(order.delivery_mode || '').toLowerCase() === 'pickup';
  
    try {
      const confirm = await Swal.fire({
        title: `¿Avanzar a ${nextStatus}?`,
        html: `<strong>Cliente:</strong> ${order.customer_name || 'Sin cliente'}<br/>
               <strong>Pedido:</strong> ${order.erp_order_id || 'Sin número'}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, avanzar',
        cancelButtonText: 'No',
        onOpen: forceSwalZindex
      });
      
      if (!confirm.isConfirmed) return;
      
      if (nextStatus === 'facturado') {
        setFacturandoId(order.id);
        try {
          // Para Cliente_pasa, crear turno en checkins
          if (isPickup) {
            try {
              
              await axios.post(`/api/foraneos/${order.id}/pickup-and-send`, {
                checkin_status: 'agendado', 
                usr_agendado: user?.username || 'VWEB'
              });
              
              // Remover de la vista actual
              setOrders((prev) => {
                const copy = Array.isArray(prev) ? [...prev] : { ...prev };
                Object.keys(copy).forEach((k) => {
                  if (Array.isArray(copy[k])) {
                    copy[k] = copy[k].filter(o => o.id !== order.id);
                  }
                });
                return copy;
              });
              
              await Swal.fire({
                title: 'Turno enviado a Almacén',
                html: `
                  <div style="text-align:left">
                    <p>El pedido <b>${order.erp_order_id}</b> ha sido enviado a Almacén.</p>
                    <p>Aparecerá en la sección <b>"Cliente pasa"</b> del modal de check-in.</p>
                  </div>
                `,
                icon: 'success',
                onOpen: forceSwalZindex
              });
            } catch (err) {
              const msg = err?.response?.data?.message || '';
              if (!/ya existe un turno activo/i.test(msg)) { throw err; }
            }
          } else {
            // Para otros carriers, facturar normal
            await axios.post(`/api/foraneos/${order.id}/facturar`, {});
            await Swal.fire({
              title: 'Actualizado',
              text: `El pedido ahora está en estatus: ${nextStatus}.`,
              icon: 'success',
              onOpen: forceSwalZindex
            });
          }
        } finally {
          setFacturandoId(null);
        }
      } else {
        await axios.put(`/api/foraneos/${order.id}/status`, { newStatus: nextStatus });
        await Swal.fire({
          title: 'Actualizado',
          text: `El pedido ahora está en estatus: ${nextStatus}.`,
          icon: 'success',
          onOpen: forceSwalZindex
        });
      }
  
      fetchRemoteOrders();
    } catch (err) {
      console.error('[NEXT_STEP_ERROR]', err);
      setFacturandoId(null);
      Swal.fire({
        title: 'Error',
        text: err?.response?.data?.message || 'No se pudo avanzar el pedido',
        icon: 'error',
        onOpen: forceSwalZindex
      });
    }
  };
    
    const getNextStatus = (currentStatus) => {
    const flow = ['aplicando pago', 'facturado', 'surtiendo', 'surtido', 'empacando', 'enviado', 'entregado'];
    const index = flow.indexOf((currentStatus || '').toLowerCase());
    return index !== -1 && index < flow.length - 1 ? flow[index + 1] : currentStatus;
  };




  const renderWaitingCard = (order, index) => {
    const fmtHoraMX = (ts) => {
      if (!ts) return '—';
      const d = new Date(ts);
      return new Intl.DateTimeFormat('es-MX', {
        timeZone: 'America/Mexico_City',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }).format(d);
    };
  
    const elapsed = timeSince(order.last_status_change_at);
  
    const clienteConCredito = Number(order?.has_credit_note) === 1;
    const pagoContraEntrega = Number(order?.pay_on_delivery) === 1;
  
    const vouchers = Array.isArray(order?.voucher_files)
      ? order.voucher_files
      : String(order?.voucher_file_url || '')
          .split(',')
          .map(s => s.trim())
          .filter(Boolean);
  
    const erpGroup = Array.isArray(order?.erp_group_list)
      ? order.erp_group_list
      : String(order?.erp_group_csv || '')
          .split(',')
          .map(s => s.trim())
          .filter(Boolean);
  
    const showVoucherButton = !(clienteConCredito || pagoContraEntrega) && vouchers.length > 0;
  
    const canEditERP = isCajera && !isSoloVista && erpGroup.length > 0;
  
    const isPickup =
      String(order.delivery_mode || '').toLowerCase() === 'pickup' ||
      String(order.carrier || '').toUpperCase() === 'CLIENTE';
    const carrierLabel = isPickup ? 'Cliente pasa' : (order.carrier || '—');
  
    return (
      <div
        key={order.id}
        style={{
          border: '1px solid #ddd',
          borderRadius: '8px',
          padding: '1rem',
          marginBottom: '1rem',
          backgroundColor: '#fafafa',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          fontSize: '0.9rem',
          position: 'relative',
        }}
      >
        <TurnoHeader order={order} elapsed={elapsed} color="#1976d2" textColor="#fff" />
  
        <p style={{ fontWeight: 'bold', fontSize: '1rem', marginBottom: '0.5rem' }}>
          {order.customer_name}
        </p>
  
        <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginBottom: 6 }}>
          <p style={{ margin:0 }}>
            <strong>{order.erp_order_id}</strong>
          </p>
  
          {canEditERP && (
            <button
              onClick={() => editMainERP(order)}
              style={{
                background: '#ECEFF1',
                color: '#263238',
                padding: '3px 8px',
                borderRadius: 6,
                border: '1px solid #CFD8DC',
                cursor: 'pointer',
                fontSize: 12,
                fontWeight: 700
              }}
              title="Editar ERP principal (sólo tras consolidar)"
            >
               <span role="img" aria-label="lapiz">✏️</span> Ingresar PC
            </button>
          )}
        </div>
  
        <div style={{ marginTop: 2, fontSize: 12, color: '#6b7280' }}>
        <span role="img" aria-label="Hora">🕒</span> <b>Hora de registro:</b> {fmtHoraMX(order.created_at)}
        </div>
  
        <div style={{ marginTop: 6 }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
            <div style={{ fontSize: 12, color: '#666' }}>
              Pedidos ({erpGroup.length})
            </div>
          </div>
  
          {erpGroup.length > 0 && (
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 4 }}>
              {erpGroup.map((erp) => (
                <span
                  key={erp}
                  style={{
                    background: '#E3F2FD',
                    color: '#0D47A1',
                    border: '1px solid #90CAF9',
                    borderRadius: 999,
                    padding: '2px 8px',
                    fontSize: 12,
                    lineHeight: 1.6,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6
                  }}
                  title={`ERP consolidado ${erp}`}
                >
                  {erp}
                </span>
              ))}
            </div>
          )}
        </div>
  
        <p style={{ marginTop: 8 }}>
          <b>Vendedor:</b> {order.sales_person || 'No asignado'}
        </p>
  
        <p>
          <strong>Paquetería:</strong> {carrierLabel}
          {Number(order?.invoice_required) === 1 && (
            <span
              style={{
                marginLeft: 8,
                padding: '2px 6px',
                background: '#ffe0b2',
                color: '#bf360c',
                borderRadius: 6,
                fontSize: 11,
              }}
              title="Este turno requiere factura"
            >
              Factura
            </span>
          )}
        </p>
  
        {Number(order.invoice_required) === 1 && (order.tax_regimen || order.cfdi_use) && (
          <div
            style={{
              marginTop: 6,
              background: '#fff',
              border: '1px dashed #ffcc80',
              borderRadius: 8,
              padding: '6px 8px',
              fontSize: 12,
              color: '#5d4037',
            }}
          >
            {order.tax_regimen && (
              <div>
                <b>Régimen:</b> {order.tax_regimen}
              </div>
            )}
            {order.cfdi_use && (
              <div>
                <b>Uso CFDI:</b> {order.cfdi_use}
              </div>
            )}
          </div>
        )}
  
        {order.advisor_comment && String(order.advisor_comment).trim() !== '' && (
          <div
            style={{
              marginTop: '8px',
              background: '#fff',
              border: '1px dashed #90caf9',
              borderRadius: '8px',
              padding: '8px 10px',
              lineHeight: 1.3,
            }}
          >
            <strong>Comentario:</strong>
            <div style={{ whiteSpace: 'pre-wrap', marginTop: 4 }}>{order.advisor_comment}</div>
          </div>
        )}
  
        <div
          style={{
            marginTop: 10,
            display: 'flex',
            gap: 10,
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          {clienteConCredito && (
            <span
              style={{
                display: 'inline-block',
                backgroundColor: '#455A64',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: '5px',
                fontWeight: 'bold',
              }}
              title="Tiene nota de crédito / saldo a favor"
            >
              <span role="img" aria-label="credito">💳 </span>Cliente con crédito
            </span>
          )}
  
          {pagoContraEntrega && (
            <span
              style={{
                display: 'inline-block',
                backgroundColor: '#2E7D32',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: 5,
                fontWeight: 'bold',
              }}
              title="Pago contra entrega"
            >
               <span role="img" aria-label="contra/entrega">💵 </span> Pago contra entrega
            </span>
          )}
  
          {showVoucherButton &&
            (vouchers.length === 1 ? (
              <button
                onClick={() =>
                  window.open(`http://pos.miplayera.com.mx:3001/${vouchers[0]}`, '_blank')
                }
                style={{
                  background: '#0069C0',
                  color: '#fff',
                  padding: '6px 10px',
                  borderRadius: 5,
                  border: 'none',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              > <span role="img" aria-label="adjunto">📎</span> Ver comprobante
              </button>
            ) : (
              <div style={{ position: 'relative' }}>
                <button
                  onClick={(e) => {
                    const menu = e.currentTarget.nextSibling;
                    menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
                  }}
                  style={{
                    background: '#0069C0',
                    color: '#fff',
                    padding: '6px 10px',
                    borderRadius: 5,
                    border: 'none',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                  }}
                >
                  
                  <span role="img" aria-label="adjunto">📎</span> Comprobantes ({vouchers.length})
                </button>
                <div
                  style={{
                    display: 'none',
                    position: 'absolute',
                    top: '110%',
                    left: 0,
                    minWidth: 220,
                    background: '#fff',
                    border: '1px solid #ddd',
                    borderRadius: 6,
                    boxShadow: '0 6px 16px rgba(0,0,0,.12)',
                    zIndex: 10,
                  }}
                >
                  {vouchers.map((relUrl, i) => (
                    <button
                      key={relUrl + i}
                      onClick={() =>
                        window.open(`http://pos.miplayera.com.mx:3001/${relUrl}`, '_blank')
                      }
                      style={{
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        padding: '8px 10px',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                    >
                       <span role="img" aria-label="comprobante">📄</span> Ver comprobante {i + 1}
                    </button>
                  ))}
                </div>
              </div>
            ))}
        </div>
  
        <div style={{ marginTop: '12px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button
            onClick={() => handlePrint(order)}
            style={{
              backgroundColor: '#1976d2',
              color: '#fff',
              padding: '6px 12px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
            }}
          >
            <span role="img" aria-label="imprimir">🖨️</span> Imprimir
          </button>
  
          {!isSoloVista && (
            <button
  onClick={() => handleNextStepCajera(order)}
  style={{
    backgroundColor: '#00796b',
    color: '#fff',
    padding: '6px 12px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    opacity: facturandoId ? 0.8 : 1
  }}
  disabled={!!facturandoId}
>
  {facturandoId === order.id ? (
    <>
      <Icon className="spin" style={{ marginRight: 6 }}>autorenew</Icon>
      Cargando…
    </>
  ) : (
    '📦 Facturar'
  )}
</button>
          )}
  
          {!isSoloVista && (
            <button
              onClick={() => handleReturnToAdvisor(order)}
              style={{
                backgroundColor: '#ff9800',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
              title="Regresar el turno al asesor con un motivo"
            >
              <span role="img" aria-label="regresar">↩️ </span>Regresar a asesor
            </button>
          )}
  
          {!isSoloVista && (
            <button
              onClick={() => handleCancelOrder(order)}
              style={{
                backgroundColor: '#d32f2f',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
               <span role="img" aria-label="cancelar">↩ ❌ </span> Cancelar
            </button>
          )}
        </div>
      </div>
    );
  };
    


  const renderDespachadorCard = (order) => {
    const elapsed = timeSince(order.last_status_change_at);  

    return (
      <div key={order.id} style={{ ...styles.modalCard, position: 'relative' }}>
        <TurnoHeader order={order} elapsed={elapsed} color="#8E24AA" textColor="#fff" />
  
        <h3 style={styles.nameCheckin}>{order.customer_name || 'Sin cliente'}</h3>
        <h3 style={styles.turnCheckin}>{order.erp_order_id || 'Sin número'}</h3>
  
        <ConsolidatedViewer order={order} />
        <p><b>Vendedor:</b> {order.sales_person || 'No asignado'}</p>
        <p><b>Paquetería:</b> {order.carrier || '—'}</p>
        <p>
  <FaBoxOpen style={{ marginRight: 4 }} />
  <b>Piezas:</b> {order.quantity_total ?? '—'}
</p>

        <FacturaFueraHorarioBadge order={order} />
        {order.advisor_comment && String(order.advisor_comment).trim() !== '' && (
          <div
            style={{
              marginTop: '8px',
              background: '#fff',
              border: '1px dashed #90caf9',
              borderRadius: '8px',
              padding: '8px 10px',
              lineHeight: 1.3,
            }}
          >
            <strong>Comentario:</strong>
            <div style={{ whiteSpace: 'pre-wrap', marginTop: 4 }}>{order.advisor_comment}</div>
          </div>
        )}
<SurtidorPill name={order.surtidor_name || order.assigned_to_name || order.assigned_to || ''} />

  
  
        <AsyncSelect
          cacheOptions
          defaultOptions
          loadOptions={loadAgentsDept007}
          value={selectedAgents[order.id] || null}
          onChange={(selected) => setSelectedAgents(prev => ({ ...prev, [order.id]: selected }))}
          placeholder="Asignar despachador"
        />
  
        <div style={{ marginTop: 10, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          {renderGuideButtons(order)}
        </div>
  
        <div style={{ marginTop: '12px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
  {!isSoloVista && (
    <button
      onClick={() => handleAssignDespachador(order)}
      style={{
        backgroundColor: '#8E24AA',
        color: '#fff',
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}
    >
      <MdLocalShipping /> Confirmar Despachador
    </button>
  )}

  {!isSoloVista && (
    <button
      onClick={() => handleReturnToAdvisor(order)}
      style={{
        backgroundColor: '#ff9800',
        color: '#fff',
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer'
      }}
      title="Regresar el turno al asesor con un motivo"
    >
      <span role="img" aria-label="regresar">↩️ </span> Regresar a asesor
    </button>
  )}

  <button
    onClick={() => handlePrint(order)}
    style={{
      backgroundColor: '#1976d2',
      color: '#fff',
      padding: '6px 12px',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '6px'
    }}
  >
    <FaPrint /> Imprimir
  </button>
</div>
      </div>
    );
  };
  
const loadAgentsDept007 = async (inputValue = '') => {
  const siteRaw = getUserSite(user);
  const site = String(siteRaw || '').match(/\b(3000|3100)\b/)?.[1];
  if (!site) return [];

  const q = String(inputValue || '').trim();

  const userLogin = String(user?.user || user?.username || user?.usr || user?.name || '')
    .trim()
    .toLowerCase();

  const deptId = String(user?.departmentId || user?.department_id || '').trim();

  try {
    const { data } = await axios.get('/api/warehouse-agents/options', {
      params: { site, q },
      headers: {
        'x-user-login': userLogin,
        'x-user-department': deptId,
        'x-user-site': site,
      },
      withCredentials: true,
    });

    const arr = Array.isArray(data) ? data : (data?.data || []);
    return arr.map(a => ({
      label: a.name,
      value: a.sales_person_id || a.id,
      code:  a.sales_person_id || a.id,
      username: a.username,
      site: a.site
    }));
  } catch (e) {
    console.error('[loadAgentsDept007] error', e);
    return [];
  }
};
  const loadDriversOrCarrier = (order) => (inputValue = '') => {
    const drivers = (catalog?.agents || [])
      .filter(a => a.departmentId === '007')
      .filter(a => a.name.toLowerCase().includes(inputValue.toLowerCase()))
      .map(a => ({ label: a.name, value: String(a.id), type: 'driver' }));

    const carrier = order?.carrier
      ? [{ label: `Paquetería: ${order.carrier}`, value: `carrier:${order.carrier}`, type: 'carrier' }]
      : [];

    return Promise.resolve([...drivers, ...carrier]);
  };


  const handleDeliver = async (order) => {
    const selected = selectedAgents[order.id];

    if (!selected) {
      Swal.fire({
        title: 'Selecciona un chofer o paquetería antes de marcar como entregado',
        onOpen: () => {
          const c = document.querySelector('.swal2-container');
          if (c) { c.style.zIndex = '99999'; c.style.position = 'fixed'; }
        }
      });
      return;
    }

    const isCarrier = String(selected.value).startsWith('carrier:');

    const selectedCarrier =
      (selected.meta) ||
      (selected.label ? selected.label.replace(/^Paquetería:\s*/i, '') : null) ||
      order.carrier ||
      null;

    const body = isCarrier
      ? {
          isCarrier: true,
          carrier: selectedCarrier,
          agentId: null,
          agentName: `Paquetería: ${selectedCarrier}`,
          deliveredVia: 'carrier'
        }
      : {
          isCarrier: false,
          carrier: null,
          agentId: selected.value,
          agentName: selected.label,
          deliveredVia: 'driver'
        };

    try {
      await axios.put(`/api/foraneos/${order.id}/deliver`, body);

      Swal.fire({
        title: 'Pedido entregado correctamente',
        onOpen: () => {
          const c = document.querySelector('.swal2-container');
          if (c) { c.style.zIndex = '99999'; c.style.position = 'fixed'; }
        }
      });

      fetchRemoteOrders();
    } catch (err) {
      console.error(err);
      Swal.fire({
        title: 'Error al marcar como entregado',
        text: err?.response?.data?.message || '',
        onOpen: () => {
          const c = document.querySelector('.swal2-container');
          if (c) { c.style.zIndex = '99999'; c.style.position = 'fixed'; }
        }
      });
    }
  };

  const handlePackOrder = async (order) => {
    const agent = selectedAgents[order.id];
    if (!agent) {
      return Swal.fire({
        title: 'Agente no asignado',
        text: 'Debes seleccionar un agente antes de empacar',
        icon: 'warning',
        confirmButtonText: 'OK',
        onOpen: forceSwalZindex
      });
    }
  
    try {
      const confirm = await Swal.fire({
        title: `¿Empacar pedido?`,
        html: `<strong>Cliente:</strong> ${order.customer_name || 'Sin nombre'}<br/>
               <strong>Pedido:</strong> ${order.erp_order_id || 'Sin número'}<br/>
               <strong>Agente:</strong> ${agent.label}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, empacar',
        onOpen: forceSwalZindex
      });
  
      if (!confirm.isConfirmed) return;
  
      await axios.put(`/api/foraneos/${order.id}/pack`, {
        agentId: agent.value,
        agentName: agent.label
      });
  
      await Swal.fire({
        title: 'Listo',
        text: `Pedido marcado como empacando por ${agent.label}`,
        icon: 'success',
        onOpen: forceSwalZindex
      });
  
      fetchRemoteOrders();
    } catch (err) {
      console.error('[PACK_ORDER_ERROR]', err);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo empacar el pedido',
        icon: 'error',
        onOpen: forceSwalZindex
      });
    }
  };

  const getErpIdsToPrint = (order) => {
    const main = String(order?.erp_order_id || '').trim().toUpperCase();
    const group = getErpGroup(order).map(s => String(s || '').trim().toUpperCase());
    return _.uniq([main, ...group]).filter(Boolean);
  };
  
  const fetchERP = async (erpId) => {
    const url = `http://miplayera2.dyndns.org:8810/gmpPlatforms/rest/SalesOrder/read?salesOrderId=${encodeURIComponent(erpId)}`;
    const res = await axios.get(url);
    const raw = res.data?.read?.[0];
    const data = raw?.data?.[0] || raw?.data;
    if (!data) throw new Error(`Pedido no válido: ${erpId}`);
    return data;
  };
  
  const buildPrintPayload = ({ order, erpId, data, userName, area }) => {
    const printMode =
      area === "007" ? "almacen" :
      area === "004" ? "caja" :
      "both";
  
    return {
      printMode, 
      numeroPedido: erpId || order.erp_order_id || data.salesOrderId || "",
      remision: data.remisionId || "",
      cliente: data.customer || order.customer_name || "",
      vendedor: data.salesPerson || order.sales_person || "",
      comentarios: data.remarks || "",
      direccion: data.address || "",
      fecha: data.orderDate || "",
      status: data.status || "",
      subtotal: data.subtotal || data.subTotal || 0,
      descuento: data.discount || 0,
      iva: data.IVA || data.iva || 0,
      total: data.total || 0,
      rfc: data.rfc || "",
      usuario: userName || "---",
      articulos: data.detail || [],
      invoice: data.invoiceId || "",
      area: area || ""
    };
  };
       
const handlePrint = async (order) => {
  try {
    const idsRaw = (getErpIdsToPrint(order) || []).filter(Boolean);
    const ids = Array.from(new Set(idsRaw));

    if (!ids.length) {
      await Swal.fire({
        icon: "warning",
        title: "Sin pedidos",
        text: "No se encontraron IDs para imprimir en este turno.",
        confirmButtonText: "OK",
        onOpen: forceSwalZindex,
      });
      return;
    }

    let selectedIds = [ids[0]];

    if (ids.length > 1) {
      const escapeHtml = (s) =>
        String(s).replace(/[&<>"']/g, (m) => ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;",
        }[m]));

      const idsHtml = ids
        .map((id) => {
          const safe = escapeHtml(id);
          return `
            <label class="print-item">
              <input type="checkbox" class="print-item__chk" value="${safe}" checked />
              <span>🧾 ${safe}</span>
            </label>
          `;
        })
        .join("");

      const swalWidth = Math.min(980, (window?.innerWidth || 1200) - 60);

      const resp = await Swal.fire({
        title: "Este turno tiene pedidos consolidados",
        html: `
          <div style="margin-top:-6px">Selecciona <b>uno o varios</b> pedidos a imprimir:</div>

          <div class="print-toolbar">
            <label class="print-all">
              <input type="checkbox" id="chk_all" checked />
              <span>Seleccionar todos</span>
            </label>

            <div class="print-count">
              Seleccionados: <b id="sel_count">${ids.length}</b>/${ids.length}
            </div>
          </div>

          <div id="ids_grid" class="print-grid">
            ${idsHtml}
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: "Imprimir seleccionados",
        cancelButtonText: "Cancelar",
        width: swalWidth,
        padding: "1.1rem 1.3rem",
        heightAuto: false,
        customClass: { popup: "swal-print-picker" },
        backdrop: "rgba(0,0,0,.80)",

        onOpen: (popupEl) => {
          if (typeof forceSwalZindex === "function") forceSwalZindex();

          const popup = popupEl || Swal.getPopup();
          const all = popup.querySelector("#chk_all");
          const count = popup.querySelector("#sel_count");
          const checks = Array.from(popup.querySelectorAll(".print-item__chk"));

          const update = () => {
            const checked = checks.filter((c) => c.checked);
            count.textContent = String(checked.length);

            const allChecked = checked.length === checks.length;
            all.checked = allChecked;
            all.indeterminate = checked.length > 0 && !allChecked;
          };

          all.addEventListener("change", () => {
            const v = all.checked;
            checks.forEach((c) => (c.checked = v));
            update();
          });

          checks.forEach((c) => c.addEventListener("change", update));
          update();
        },

        preConfirm: () => {
          const popup = Swal.getPopup();
          const selected = Array.from(popup.querySelectorAll(".print-item__chk:checked"))
            .map((i) => i.value)
            .filter(Boolean);

          if (!selected.length) {
            Swal.showValidationMessage("Selecciona al menos un pedido para continuar");
            return null;
          }

          return selected;
        },
      });

      if (!resp.isConfirmed) return;
      selectedIds = resp.value;
    }

    const idsToPrint = Array.isArray(selectedIds) ? selectedIds : [selectedIds];

    let userLocal = {};
    try {
      userLocal = JSON.parse(localStorage.getItem("user")) || {};
    } catch (e) {
      userLocal = {};
    }

    const userName = userLocal?.name || userLocal?.username || "---";
    const area = userLocal?.departmentId || "";

    const settled = await Promise.allSettled(idsToPrint.map((erpId) => fetchERP(erpId)));

    const okRows = [];
    const failed = [];

    settled.forEach((r, idx) => {
      const erpId = idsToPrint[idx];

      if (r.status === "fulfilled") {
        const payload = buildPrintPayload({
          order,
          erpId,
          data: r.value,
          userName,
          area,
        });

        okRows.push({
          erpId: String(erpId || "").trim().toUpperCase(),
          payload,
        });
      } else {
        failed.push(erpId);
      }
    });

    if (!okRows.length) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo generar la impresión",
        confirmButtonText: "OK",
        onOpen: forceSwalZindex,
      });
      return;
    }

    if (failed.length) {
      await Swal.fire({
        icon: "warning",
        title: "No se pudo cargar el pedido",
        html: `No se pudo traer: <br/><b>${failed.join(", ")}</b>`,
        confirmButtonText: "OK",
        onOpen: forceSwalZindex,
      });
    }

    const auditSettled = await Promise.allSettled(
      okRows.map(({ erpId }) => {
        if (!erpId) {
          return Promise.resolve({ data: { data: {} } });
        }

        return axios.post("/api/print-audit/register", {
          module: "foraneos",
          order_key: erpId,
          printed_by: userName,
        });
      })
    );

    const payloadsWithAudit = okRows.map(({ payload }, idx) => {
      const auditResp =
        auditSettled[idx]?.status === "fulfilled"
          ? auditSettled[idx].value
          : null;

      const audit = auditResp?.data?.data || {};

      return {
        ...payload,
        is_copy: !!audit.is_copy,
        show_copy_watermark: !!audit.is_copy,
        print_count: Number(audit.print_count || 0),
        watermark_text: audit.watermark_text || "",
        watermarkText: audit.watermark_text || "",
      };
    });

    setPrintData(payloadsWithAudit);
    setPrintOpen(true);
  } catch (error) {
    console.error("[ERROR] Error al preparar impresión:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: error?.message || "Hubo un problema al generar la impresión",
      confirmButtonText: "OK",
      onOpen: forceSwalZindex,
    });
  }
};            
  
  const handleCancelOrder = async (order) => {
    try {
      const confirm = await Swal.fire({
        title: `¿Cancelar pedido?`,
        html: `<strong>Cliente:</strong> ${order.customer_name || 'Sin cliente'}<br/><strong>Pedido:</strong> ${order.erp_order_id || 'Sin número'}`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, cancelar',
        cancelButtonText: 'No',
        onOpen: forceSwalZindex
      });

      if (!confirm.isConfirmed) return;

      await axios.put(`/api/foraneos/${order.id}/status`, {
        newStatus: 'cancelado'
      });

      await Swal.fire({
        title: 'Cancelado',
        text: 'El pedido ha sido marcado como cancelado.',
        icon: 'success',
        onOpen: forceSwalZindex
      });

      fetchRemoteOrders();
    } catch (err) {
      console.error('[CANCEL_ORDER_ERROR]', err);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo cancelar el pedido',
        icon: 'error',
        onOpen: forceSwalZindex
      });
    }
  };

  const handleShipOrder = async (order) => {
    try {
      const confirm = await Swal.fire({
        title: `¿Marcar como enviado?`,
        html: `<strong>Cliente:</strong> ${order.customer_name || 'Sin cliente'}<br/><strong>Pedido:</strong> ${order.erp_order_id || 'Sin número'}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, enviar',
        onOpen: forceSwalZindex,
      });

      if (!confirm.isConfirmed) return;

      await axios.put(`/api/foraneos/${order.id}/status`, {
        newStatus: 'enviado'
      });

      await Swal.fire({
        title: 'Enviado',
        html: `<strong>Cliente:</strong> ${order.customer_name || 'Sin cliente'}<br/>Pedido <strong>${order.erp_order_id || 'Sin número'}</strong> marcado como <strong>enviado</strong>`,
        icon: 'success',
        onOpen: forceSwalZindex,
      });

      fetchRemoteOrders();
    } catch (err) {
      console.error('[SHIP_ORDER_ERROR]', err);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo marcar como enviado',
        icon: 'error',
        onOpen: forceSwalZindex,
      });
    }
  };

  const handleAssignSurtidor = async (order) => {
    const selected = selectedAgents[order.id];
    if (!selected) {
      return Swal.fire({
        title: 'Selecciona un surtidor',
        icon: 'info',
        confirmButtonText: 'OK',
        onOpen: forceSwalZindex
      });
    }
  
    try {
      const confirm = await Swal.fire({
        title: '¿Confirmar surtidor?',
        html: `<strong>Cliente:</strong> ${order.customer_name}<br/><strong>Pedido:</strong> ${order.erp_order_id}<br/><strong>Surtidor:</strong> ${selected.label}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, confirmar',
        cancelButtonText: 'Cancelar',
        onOpen: forceSwalZindex
      });
      if (!confirm.isConfirmed) return;
  
      await axios.put(`/api/foraneos/${order.id}/assign-surtidor`, {
        surtidor_id: selected.value,
        surtidor_name: selected.label
      });
  
      await axios.put(`/api/foraneos/${order.id}/status`, {
        newStatus: 'surtiendo'
      });
  
      await Swal.fire({
        title: 'Surtidor asignado',
        text: 'El pedido pasó a SURTIENDO.',
        icon: 'success',
        onOpen: forceSwalZindex
      });
  
      fetchRemoteOrders();
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'No se pudo asignar surtidor.', 'error');
    }
  };
  
  const getStatusLabel = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'aplicando pago': return 'APLICANDO PAGO';
      case 'facturado':      return 'FACTURADO';
      case 'surtiendo':      return 'SURTIENDO';
      case 'surtido':        return 'SURTIDO';
      case 'empacando':      return 'EMPACADO';
      case 'enviado':        return 'ENVIADO';
      case 'entregado':      return 'ENTREGADO';
      case 'cancelado':      return 'CANCELADO';
      default:               return (status || '').toUpperCase();
    }
  };

  const getStatusStyle = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'aplicando pago': return { backgroundColor: '#546E7A', color: '#fff' };
      case 'facturado':      return { backgroundColor: '#455A64', color: '#fff' };
      case 'surtiendo':      return { backgroundColor: '#FFD700', color: '#000' };
      case 'surtido':        return { backgroundColor: '#FF7043', color: '#fff' };
      case 'empacando':      return { backgroundColor: '#7E57C2', color: '#fff' };
      case 'enviado':        return { backgroundColor: '#2196F3', color: '#fff' };
      case 'entregado':      return { backgroundColor: '#43A047', color: '#fff' };
      case 'cancelado':      return { backgroundColor: '#D32F2F', color: '#fff' };
      default:               return { backgroundColor: '#BDBDBD', color: '#000' };
    }
  };

  const showGuides = (guiaRaw, order) => {
    const guides = String(guiaRaw || '')
      .split(/\r?\n|,|;/)
      .map(s => s.trim())
      .filter(Boolean);

    if (!guides.length) {
      Swal.fire({
        title: 'Sin guías',
        text: 'Este pedido no tiene guías registradas.',
        icon: 'info',
        onOpen: forceSwalZindex
      });
      return;
    }

    Swal.fire({
      title: `Guías (${guides.length})`,
      html: `
        <div style="text-align:left;max-height:280px;overflow:auto;">
          <p><strong>Cliente:</strong> ${order.customer_name || 'No disponible'}</p>
          <p><strong>Pedido:</strong> ${order.erp_order_id || 'No disponible'}</p>
          <hr/>
          ${guides.map(g => `• <code>${g}</code>`).join('<br/>')}
        </div>
      `,
      confirmButtonText: 'Cerrar',
      showCancelButton: true,
      cancelButtonText: 'Copiar todas',
      onOpen: forceSwalZindex
    }).then(async (res) => {
      if (res.dismiss === Swal.DismissReason.cancel || res.dismiss === 'cancel') {
        await navigator.clipboard.writeText(guides.join('\n'));
        Swal.fire({
          title: 'Copiado',
          text: 'Todas las guías fueron copiadas al portapapeles.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false,
          onOpen: forceSwalZindex
        });
      }
    });
  };

  const editGuides = async (order) => {
    const initial = String(order.guia || '').replace(/,/g, '\n');

    const { value: text, isConfirmed } = await Swal.fire({
      title: 'Editar guías',
      input: 'textarea',
      inputValue: initial,
      inputPlaceholder: 'Una guía por línea (o separadas por coma/;)',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      onOpen: forceSwalZindex
    });

    if (!isConfirmed) return;

    const normalized = String(text || '')
      .split(/\r?\n|,|;/)
      .map(s => s.trim())
      .filter(Boolean)
      .join('\n');

    try {
      await axios.put(`/api/foraneos/${order.id}/guia`, { guia: normalized });
      Swal.fire({ title: 'Guías actualizadas', icon: 'success', timer: 1300, showConfirmButton: false, onOpen: forceSwalZindex });
      fetchRemoteOrders();
    } catch (err) {
      console.error(err);
      Swal.fire({ title: 'Error', text: 'No se pudieron actualizar las guías.', icon: 'error', onOpen: forceSwalZindex });
    }
  };

  const renderSurtidorCard = (order, index) => {
    const elapsed = timeSince(order.last_status_change_at);
  
    return (
      <div key={order.id} style={{ ...styles.modalCard, position: 'relative' }}>
        <TurnoHeader order={order} elapsed={elapsed} color="#00897b" textColor="#fff" />
  
        <h3 style={styles.nameCheckin}>{order.customer_name || 'Sin cliente'}</h3>
        <h3 style={styles.turnCheckin}>{order.erp_order_id || 'Sin número'}</h3>
  
        <ConsolidatedViewer order={order} />
        <p><b>Vendedor:</b> {order.sales_person || 'No asignado'}</p>
        <p><strong>Paquetería:</strong> {order.carrier || '—'}</p>
        <p>
  <FaBoxOpen style={{ marginRight: 4 }} />
  <b>Piezas:</b> {order.quantity_total ?? '—'}
</p>

        <FacturaFueraHorarioBadge order={order} />
        {order.advisor_comment && String(order.advisor_comment).trim() !== '' && (
          <div
            style={{
              marginTop: '8px',
              background: '#fff',
              border: '1px dashed #90caf9',
              borderRadius: '8px',
              padding: '8px 10px',
              lineHeight: 1.3,
            }}
          >
            <strong>Comentario:</strong>
            <div style={{ whiteSpace: 'pre-wrap', marginTop: 4 }}>{order.advisor_comment}</div>
          </div>
        )}
        <div style={{ marginTop: 10, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          {renderGuideButtons(order)}
        </div>
          <AsyncSelect
          cacheOptions
          defaultOptions
          loadOptions={loadAgentsDept007}
          value={selectedAgents[order.id] || null}
          onChange={(selected) =>
            setSelectedAgents(prev => ({ ...prev, [order.id]: selected }))
          }
          placeholder="Asignar Surtidor"
        />
  
        <div style={{ marginTop: '12px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          {!isSoloVista && (
            <button
              onClick={() => handleAssignSurtidor(order)}
              style={{
                backgroundColor: '#00897b',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <FaPeopleCarry /> Confirmar Surtidor
            </button>
          )}
  

          <button
            onClick={() => handlePrint(order)}
            style={{
              backgroundColor: '#1976d2',
              color: '#fff',
              padding: '6px 12px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <FaPrint /> Imprimir
          </button>
          {!isSoloVista && (
            <button
              onClick={() => handleReturnToAdvisor(order)}
              style={{
                backgroundColor: '#ff9800',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
              title="Regresar el turno al asesor con un motivo"
            >
              <span role="img" aria-label="regresar">↩️ </span>  Regresar a asesor
            </button>
          )}

  
          {!isSoloVista && (
            <button
              onClick={() => handleCancelOrder(order)}
              style={{
                backgroundColor: '#d32f2f',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              <MdCancel /> Cancelar
            </button>
          )}
        </div>
      </div>
    );
  };  
  const renderSurtiendoCard = (order) => {
    const elapsed = timeSince(order.last_status_change_at);
  
    
    const pagoContraEntrega = Number(order?.pay_on_delivery) === 1;
  
    const editKey = _editKey(order.id, 'surtidor');
  
    return (
      <div key={order.id} style={{ ...styles.modalCard, position: 'relative' }}>
        <TurnoHeader order={order} elapsed={elapsed} color="#FFD700" textColor="#000" />
  
        <h3 style={styles.nameCheckin}>{order.customer_name || 'Sin cliente'}</h3>
        <h3 style={styles.turnCheckin}>{order.erp_order_id || 'Sin número'}</h3>
  
        <ConsolidatedViewer order={order} />
        <p><b>Vendedor:</b> {order.sales_person || 'No asignado'}</p>
        <p><b>Paquetería:</b> {order.carrier || '—'}</p>
        <p>
  <FaBoxOpen style={{ marginRight: 4 }} />
  <b>Piezas:</b> {order.quantity_total ?? '—'}
</p>

        <FacturaFueraHorarioBadge order={order} />
        <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
        <SurtidorPill name={order.surtidor_name || order.assigned_to_name || order.assigned_to || ''} />
        {!isSoloVista && !isEditing(order.id, 'surtidor') && (
            <button
              onClick={() => startEdit(order, 'surtidor', order.surtidor_name, order.surtidor_id)}
              style={{ background:'#ECEFF1', color:'#263238', padding:'3px 8px', borderRadius:6,
                       border:'1px solid #CFD8DC', cursor:'pointer', fontSize:12, fontWeight:700 }}
              title="Editar surtidor"
            >
              <span role="img" aria-label="editar">✏️ </span>Editar
            </button>
          )}
        </div>
  
        {isEditing(order.id, 'surtidor') && !isSoloVista && (
          <div style={{ marginTop: 8, display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadAgentsDept007}
              value={editSelected[editKey] || null}
              onChange={(opt) => setEditSelected(prev => ({ ...prev, [editKey]: opt }))}
              placeholder="Seleccionar nuevo surtidor"
              styles={{ container: (base) => ({ ...base, minWidth: 260 }) }}
            />
            <button
              onClick={() => saveEditSurtidor(order)}
              style={{ background:'#00796b', color:'#fff', padding:'6px 10px', border:'none', borderRadius:6, cursor:'pointer' }}
            >
              Guardar
            </button>
            <button
              onClick={() => cancelEdit(order.id, 'surtidor')}
              style={{ background:'#B0BEC5', color:'#263238', padding:'6px 10px', border:'none', borderRadius:6, cursor:'pointer' }}
            >
              Cancelar
            </button>
        </div>
        )}
  
        {order.advisor_comment && String(order.advisor_comment).trim() !== '' && (
          <div
            style={{
              marginTop: '8px',
              background: '#fff',
              border: '1px dashed #90caf9',
              borderRadius: '8px',
              padding: '8px 10px',
              lineHeight: 1.3,
            }}
          >
            <strong>Comentario:</strong>
            <div style={{ whiteSpace: 'pre-wrap', marginTop: 4 }}>{order.advisor_comment}</div>
          </div>
        )}
          <div style={{ marginTop: 10, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          {renderGuideButtons(order)}
        </div>
  
        <div style={{ marginTop: '12px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          {!isSoloVista && (
            <button
              onClick={() => handleMarkSurtido(order)}
              style={{
                backgroundColor: '#FF7043',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <FaPeopleCarry /> Marcar SURTIDO
            </button>
          )}
  
          {pagoContraEntrega && (
            <span
              style={{
                display: 'inline-block',
                backgroundColor: '#2E7D32',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: 5,
                fontWeight: 'bold',
              }}
              title="Pago contra entrega"
            >
              <span role="img" aria-label="pago">💵 </span> Pago contra entrega
            </span>
          )}
  
          <button
            onClick={() => handlePrint(order)}
            style={{
              backgroundColor: '#1976d2',
              color: '#fff',
              padding: '6px 12px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <FaPrint /> Imprimir
          </button>
          {!isSoloVista && (
    <button
      onClick={() => handleReturnToAdvisor(order)}
      style={{
        backgroundColor: '#ff9800',
        color: '#fff',
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer'
      }}
      title="Regresar el turno al asesor con un motivo"
    >
      <span role="img" aria-label="regresar">↩️ </span>  Regresar a asesor
    </button>
  )}
          {!isSoloVista && (
            <button
              onClick={() => handleCancelOrder(order)}
              style={{
                backgroundColor: '#d32f2f',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              <MdCancel /> Cancelar
            </button>
          )}
        </div>
      </div>
    );
  };
  const renderEmpacandoCard = (order, index) => {
    const elapsed = timeSince(order.last_status_change_at);
    const pagoContraEntrega = Number(order?.pay_on_delivery) === 1;
    const actual = order.despachador_name || order.dispatcher_name || 'No asignado';
    const editKey = _editKey(order.id, 'despachador');
  
    return (
      <div key={order.id} style={{ ...styles.modalCard, position: 'relative' }}>
        <TurnoHeader order={order} elapsed={elapsed} color="#6a1b9a" textColor="#fff" />
  
        <h3 style={styles.nameCheckin}>{order.customer_name || 'Sin cliente'}</h3>
        <h3 style={styles.turnCheckin}>{order.erp_order_id || 'Sin número'}</h3>
  
        <ConsolidatedViewer order={order} />
        <p><b>Vendedor:</b> {order.sales_person || 'No asignado'}</p>
        <p><strong>Paquetería:</strong> {order.carrier || '—'}</p>
        <p>
  <FaBoxOpen style={{ marginRight: 4 }} />
  <b>Piezas:</b> {order.quantity_total ?? '—'}
</p>

        <FacturaFueraHorarioBadge order={order} />
        <SurtidorPill name={order.surtidor_name || order.assigned_to_name || order.assigned_to || ''} />
        <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginTop:6 }}>
          <InfoPill emoji="🚚" title="Despachador" value={actual} type="paqueteria" />
          {!isSoloVista && !isEditing(order.id, 'despachador') && (
            <button
              onClick={() => startEdit(order, 'despachador', order.despachador_name || order.dispatcher_name, order.despachador_id)}
              style={{ background:'#ECEFF1', color:'#263238', padding:'3px 8px', borderRadius:6,
                       border:'1px solid #CFD8DC', cursor:'pointer', fontSize:12, fontWeight:700 }}
              title="Editar despachador"
            >
               <span role="img" aria-label="editar">✏️</span> Editar
            </button>
          )}
        </div>
  
        {isEditing(order.id, 'despachador') && !isSoloVista && (
          <div style={{ marginTop: 8, display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadAgentsDept007}
              value={editSelected[editKey] || null}
              onChange={(opt) => setEditSelected(prev => ({ ...prev, [editKey]: opt }))}
              placeholder="Seleccionar nuevo despachador"
              styles={{ container: (base) => ({ ...base, minWidth: 260 }) }}
            />
            <button
              onClick={() => saveEditDespachador(order)}
              style={{ background:'#8E24AA', color:'#fff', padding:'6px 10px', border:'none', borderRadius:6, cursor:'pointer' }}
            >
              Guardar
            </button>
            <button
              onClick={() => cancelEdit(order.id, 'despachador')}
              style={{ background:'#B0BEC5', color:'#263238', padding:'6px 10px', border:'none', borderRadius:6, cursor:'pointer' }}
            >
              Cancelar
            </button>
          </div>
        )}
  
        {order.advisor_comment && String(order.advisor_comment).trim() !== '' && (
          <div
            style={{
              marginTop: '8px',
              background: '#fff',
              border: '1px dashed #90caf9',
              borderRadius: '8px',
              padding: '8px 10px',
              lineHeight: 1.3,
            }}
          >
            <strong>Comentario:</strong>
            <div style={{ whiteSpace: 'pre-wrap', marginTop: 4 }}>{order.advisor_comment}</div>
          </div>
        )}
          <AsyncSelect
          cacheOptions
          defaultOptions
          loadOptions={loadAgentsDept007}
          value={selectedAgents[order.id] || null}
          onChange={(selected) =>
            setSelectedAgents(prev => ({ ...prev, [order.id]: selected }))
          }
          placeholder="Asignar agente"
        />
          <div style={{ marginTop: 10, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          {renderGuideButtons(order)}
        </div>
  
        <div style={{ marginTop: '12px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          {!isSoloVista && (
            <button
              onClick={() => handlePackOrder(order)}
              style={{
                backgroundColor: '#6a1b9a',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <FaBoxOpen /> Empacar
            </button>
          )}
  
          {pagoContraEntrega && (
            <span
              style={{
                display: 'inline-block',
                backgroundColor: '#2E7D32',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: 5,
                fontWeight: 'bold',
              }}
              title="Pago contra entrega"
            >
              <span role="img" aria-label="regresar">💵</span> Pago contra entrega
            </span>
          )}
  
          <button
            onClick={() => handlePrint(order)}
            style={{
              backgroundColor: '#1976d2',
              color: '#fff',
              padding: '6px 12px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <FaPrint /> Imprimir
          </button>
          {!isSoloVista && (
    <button
      onClick={() => handleReturnToAdvisor(order)}
      style={{
        backgroundColor: '#ff9800',
        color: '#fff',
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer'
      }}
      title="Regresar el turno al asesor con un motivo"
    >

      <span role="img" aria-label="regresar">↩️</span>  Regresar a asesor
    </button>
  )}
          {!isSoloVista && (
            <button
              onClick={() => handleCancelOrder(order)}
              style={{
                backgroundColor: '#d32f2f',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <MdCancel /> Cancelar
            </button>
          )}
        </div>
      </div>
    );
  };


  const renderEnviadoCard = (order, index) => {
    const elapsed = timeSince(order.last_status_change_at);
    const pagoContraEntrega = Number(order?.pay_on_delivery) === 1;
  
    return (
      <div
        key={order.id}
        style={{
          border: '1px solid #ccc',
          borderRadius: '8px',
          padding: '1rem',
          marginBottom: '1rem',
          backgroundColor: '#fffde7',
          fontSize: '0.9rem',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          position: 'relative'
        }}
      >
        <TurnoHeader order={order} elapsed={elapsed} color="#fbc02d" textColor="#fff" />
  
        <p>{order.customer_name}</p>
        <p><strong>Pedido:</strong> {order.erp_order_id}</p>
        <ConsolidatedViewer order={order} />
  
        <p><strong>Vendedor:</strong> {order.sales_person || 'No disponible'}</p>
        <p><strong>Paquetería:</strong> {order.carrier || '—'}</p>
        <p>
  <FaBoxOpen style={{ marginRight: 4 }} />
  <b>Piezas:</b> {order.quantity_total ?? '—'}
</p>

        <FacturaFueraHorarioBadge order={order} />
        <SurtidorPill name={order.surtidor_name || order.assigned_to_name || order.assigned_to || ''} />
        <p><strong>Empacado por:</strong> {order.packed_by_name || 'No disponible'}</p>
        {order.advisor_comment && String(order.advisor_comment).trim() !== '' && (
          <div
            style={{
              marginTop: '8px',
              background: '#fff',
              border: '1px dashed #90caf9',
              borderRadius: '8px',
              padding: '8px 10px',
              lineHeight: 1.3,
            }}
          >
            <strong>Comentario:</strong>
            <div style={{ whiteSpace: 'pre-wrap', marginTop: 4 }}>{order.advisor_comment}</div>
          </div>
        )}

  
        <AsyncSelect
          cacheOptions
          defaultOptions
          loadOptions={loadDriversOrCarrier(order)}
          onChange={(selected) => {
            setSelectedAgents((prev) => ({ ...prev, [order.id]: selected }));
          }}
          placeholder="Seleccionar chofer o paquetería"
          value={selectedAgents[order.id] || null}
          styles={{ container: (base) => ({ ...base, marginTop: '10px' }) }}
        />
          <div style={{ marginTop: 10, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          {renderGuideButtons(order)}
        </div>
  
        <div style={{ marginTop: '12px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button
            onClick={() => handlePrint(order)}
            style={{
              backgroundColor: '#1976d2',
              color: '#fff',
              padding: '6px 12px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
             <span role="img" aria-label="imprimir">🖨️</span>  Imprimir
          </button>
  
          {!isSoloVista && (
            <button
              onClick={() => handleDeliver(order)}
              style={{
                backgroundColor: '#388e3c',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              <span role="img" aria-label="exito">✅</span> Entregado
            </button>
          )}
  
          {pagoContraEntrega && (
            <span
              style={{
                display: 'inline-block',
                backgroundColor: '#2E7D32',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: 5,
                fontWeight: 'bold',
              }}
              title="Pago contra entrega"
            >
               <span role="img" aria-label="exito">💵</span> Pago contra entrega
               
            </span>
          )}
   {!isSoloVista && (
    <button
      onClick={() => handleReturnToAdvisor(order)}
      style={{
        backgroundColor: '#ff9800',
        color: '#fff',
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer'
      }}
      title="Regresar el turno al asesor con un motivo"
    >
       <span role="img" aria-label="exito">↩️ </span> Regresar a asesor
      
    </button>
  )}
          {!isSoloVista && (
            <button
              onClick={() => handleCancelOrder(order)}
              style={{
                backgroundColor: '#d32f2f',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
               <span role="img" aria-label="cancelar">❌ </span> Cancelar
            </button>
          )}
        </div>
      </div>
    );
  };
  const renderEntregadoCard = (order, index) => {
    const fechaEntrega = order.delivered_at
      ? new Date(order.delivered_at).toLocaleString('es-MX', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        })
      : 'No disponible';

    return (
      <div
        key={order.id}
        style={{
          borderLeft: '6px solid #4CAF50',
          borderRadius: '10px',
          padding: '1rem',
          marginBottom: '1rem',
          backgroundColor: '#E8F5E9',
          fontSize: '0.9rem',
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
          position: 'relative',
          width: '100%',
          maxWidth: '320px',
          flex: '1 1 300px',
          minHeight: '210px',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <p style={{ margin: 0 }}><strong>Cliente:</strong> {order.customer_name}</p>
        </div>

        <p style={{ margin: '4px 0' }}><strong>Pedido:</strong> {order.erp_order_id}</p>
        <p style={{ margin: '4px 0' }}>
  <FaBoxOpen style={{ marginRight: 4 }} />
  <b>Piezas:</b> {order.quantity_total ?? '—'}
</p>

        <ConsolidatedViewer order={order} />

        <p style={{ margin: '4px 0' }}><strong>Vendedor:</strong> {order.sales_person || 'No disponible'}</p>
        <p><strong>Paquetería:</strong> {order.carrier || '—'}</p>
        <p><strong>Factura:</strong> {order.invoice_id || '—'}</p>
        {order.advisor_comment && String(order.advisor_comment).trim() !== '' && (
          <div
            style={{
              marginTop: '8px',
              background: '#fff',
              border: '1px dashed #90caf9',
              borderRadius: '8px',
              padding: '8px 10px',
              lineHeight: 1.3,
            }}
          >
            <strong>Comentario:</strong>
            <div style={{ whiteSpace: 'pre-wrap', marginTop: 4 }}>{order.advisor_comment}</div>
          </div>
        )}
        {order.guia && (
          <button
            onClick={() => showGuides(order.guia, order)}
            style={{
              margin: '6px 0 10px',
              padding: '6px 10px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              background: '#fff',
              cursor: 'pointer'
            }}
            title="Ver guías"
          >
            Ver guías
          </button>
        )}

<SurtidorPill name={order.surtidor_name || order.assigned_to_name || order.assigned_to || ''} />

        <p style={{ margin: '4px 0' }}><FaBoxOpen /> <strong>Empacado por:</strong> {order.packed_by_name || 'No disponible'}</p>
        <p style={{ margin: '4px 0' }}><MdFactCheck /> <strong>Entregado por:</strong> {order.delivered_by_name || 'No disponible'}</p>
        <p style={{ margin: '4px 0' }}><MdAccessTime /> <strong>Entregado el:</strong> {fechaEntrega}</p>
      </div>
    );
  };

  const renderEmpacandoAsignadoCard = (order, index) => {
    const elapsed = timeSince(order.last_status_change_at);
    const pagoContraEntrega = Number(order?.pay_on_delivery) === 1;
  
    const editKey = _editKey(order.id, 'empacador');
  
    return (
      <div key={order.id} style={{ ...styles.modalCard, position: 'relative' }}>
        <TurnoHeader order={order} elapsed={elapsed} color="#0288D1" textColor="#fff" />
  
        <h3 style={styles.nameCheckin}>{order.customer_name || 'Sin cliente'}</h3>
        <h3 style={styles.turnCheckin}>{order.erp_order_id || 'Sin número'}</h3>
  
        <ConsolidatedViewer order={order} />
        <p><b>Vendedor:</b> {order.sales_person || 'No asignado'}</p>
        <p><strong>Paquetería:</strong> {order.carrier || '—'}</p>
        <p>
  <FaBoxOpen style={{ marginRight: 4 }} />
  <b>Piezas:</b> {order.quantity_total ?? '—'}
</p>
        <FacturaFueraHorarioBadge order={order} />
        <SurtidorPill name={order.surtidor_name || order.assigned_to_name || order.assigned_to || ''} />
  
        <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginTop:6 }}>
        <p style={{ margin: 0 }}><b>Empacado por:</b> {order.packed_by_name || 'Sin agente'}</p>
        {!isSoloVista && !isEditing(order.id, 'empacador') && (
            <button
              onClick={() => startEdit(order, 'empacador', order.packed_by_name, order.packed_by)}
              style={{ background:'#ECEFF1', color:'#263238', padding:'3px 8px', borderRadius:6,
                       border:'1px solid #CFD8DC', cursor:'pointer', fontSize:12, fontWeight:700 }}
              title="Editar empacador"
            >
              <span role="img" aria-label="editar">✏️</span>
               Editar
            </button>
          )}
        </div>
  
        {isEditing(order.id, 'empacador') && !isSoloVista && (
          <div style={{ marginTop: 8, display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={loadAgentsDept007}
              value={editSelected[editKey] || null}
              onChange={(opt) => setEditSelected(prev => ({ ...prev, [editKey]: opt }))}
              placeholder="Seleccionar nuevo empacador"
              styles={{ container: (base) => ({ ...base, minWidth: 260 }) }}
            />
            <button
              onClick={() => saveEditEmpacador(order)}
              style={{ background:'#0288D1', color:'#fff', padding:'6px 10px', border:'none', borderRadius:6, cursor:'pointer' }}
            >
              Guardar
            </button>
            <button
              onClick={() => cancelEdit(order.id, 'empacador')}
              style={{ background:'#B0BEC5', color:'#263238', padding:'6px 10px', border:'none', borderRadius:6, cursor:'pointer' }}
            >
              Cancelar
            </button>
          </div>
        )}
  
        {order.advisor_comment && String(order.advisor_comment).trim() !== '' && (
          <div
            style={{
              marginTop: '8px',
              background: '#fff',
              border: '1px dashed #90caf9',
              borderRadius: '8px',
              padding: '8px 10px',
              lineHeight: 1.3,
            }}
          >
            <strong>Comentario:</strong>
            <div style={{ whiteSpace: 'pre-wrap', marginTop: 4 }}>{order.advisor_comment}</div>
          </div>
        )}
          <div style={{ marginTop: 10, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
          {renderGuideButtons(order)}
        </div>
  
        <div style={{ marginTop: '12px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          {!isSoloVista && (
            <button
              onClick={() => handleShipOrder(order)}
              style={{
                backgroundColor: '#00796b',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <MdLocalShipping /> Enviar
            </button>
          )}
  
          {pagoContraEntrega && (
            <span
              style={{
                display: 'inline-block',
                backgroundColor: '#2E7D32',
                color: '#fff',
                padding: '6px 10px',
                borderRadius: 5,
                fontWeight: 'bold',
              }}
              title="Pago contra entrega"
            > <span role="img" aria-label="Pago/entrega">💵</span>
               Pago contra entrega
            </span>
          )}
  
          <button
            onClick={() => handlePrint(order)}
            style={{
              backgroundColor: '#1976d2',
              color: '#fff',
              padding: '6px 12px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            <FaPrint /> Imprimir
          </button>
          {!isSoloVista && (
    <button
      onClick={() => handleReturnToAdvisor(order)}
      style={{
        backgroundColor: '#ff9800',
        color: '#fff',
        padding: '6px 12px',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer'
      }}
      title="Regresar el turno al asesor con un motivo"
    >
      <span role="img" aria-label="regresar">↩️ </span>
       Regresar a asesor
    </button>
  )}
          {!isSoloVista && (
            <button
              onClick={() => handleCancelOrder(order)}
              style={{
                backgroundColor: '#d32f2f',
                color: '#fff',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
            >
              <MdCancel /> Cancelar
            </button>
          )}
        </div>
      </div>
    );
  };
    if (!open || !statusToFetch) return null;
    const titleText =
  (isAlmacen || (isGerente && viewingAlmacen))
    ? (onlyDomicilio ? 'Pedidos Domicilio ' : 'Pedidos Foráneos ')
    : 'Pedidos Foráneos ';


  return (
    <>
      {ReactDOM.createPortal(
        (
          <div style={styles.modalBackground}>
            <div style={styles.modalContainer}>
              <style>{`
  @keyframes pulse-bg {
    0%   { filter: brightness(1); }
    50%  { filter: brightness(1.25); }
    100% { filter: brightness(1); }
  }
  .turno-badge.pend {
    animation: pulse-bg 1.4s ease-in-out infinite;
  }

  @keyframes blink-pend {
    0%, 100% { opacity: 1; }
    50%      { opacity: 0.3; }
  }
  .pendiente-blink {
    animation: blink-pend 1.2s ease-in-out infinite;
  }
.spin { animation: spin 1s linear infinite; }
  @keyframes spin { to { transform: rotate(360deg); } }

  .lds-dual-ring {
    display: inline-block;
    width: 64px;
    height: 64px;
  }
  .lds-dual-ring:after {
    content: " ";
    display: block;
    width: 48px;
    height: 48px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #1976d2;
    border-color: #1976d2 transparent #1976d2 transparent;
    animation: lds-dual-ring 1.2s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`}</style>
{facturandoId && (
  <div style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(255,255,255,0.8)',
    zIndex: 10900,                 
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <div className="lds-dual-ring" />
    <div style={{ marginTop: 12, fontWeight: 700, color: '#333' }}>
      Generando factura...
    </div>
    <div style={{ fontSize: 12, color: '#666' }}>
      No cierres esta ventana
    </div>
  </div>
)}

{!isAlmacen2 && (
  <>
    <button onClick={onClose} style={styles.closeButton}>Cerrar</button>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '8px' }}>
      <h4
        style={{
          fontWeight: 700,
          margin: 0,
          padding: '4px 12px',
          borderRadius: '8px',
          color: '#E65100',
          background: '#FFE0B2',
          lineHeight: 1.2,
          fontSize: '1.6rem'
        }}
      >
        {titleText}
      </h4>
    </div>
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        margin: '12px 0 20px'
      }}
    >
      <div style={{ width: '100%', maxWidth: 300 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '6px 14px',
            borderRadius: 999,
            backgroundColor: '#fff',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            border: '1px solid #ddd'
          }}
        >
<Icon small style={{ marginRight: 8, color: '#757575' }}>
  search
</Icon>
<input
  type="text"
  placeholder="Buscar cliente, pedido o paquetería..."
  value={searchQuery}
  onChange={(e) => setSearchQuery(e.target.value)}
  className="foraneos-search-input"
  style={{
    border: 'none',
    outline: 'none',
    width: '100%',
    fontSize: 14,
    background: 'transparent'
  }}
/>
        </div>
      </div>
    </div>
  </>
)}
{!isAlmacen2 && (
  <div
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 10,
      marginBottom: 16,
    }}
  >
  
    <button
      style={{
        ...styles.button,
        backgroundColor: '#FFA000',
        maxWidth: '200px',
        marginLeft: 0,
        display: 'inline-block'
      }}
      onClick={fetchRemoteOrders}
    >
      <MdInventory /> Actualizar
    </button>

    
    {(isGerente || isAsesorTele) && (
      <button
        style={{
          ...styles.button,
          backgroundColor: viewingAlmacen ? '#546E7A' : '#00796B',
          maxWidth: '200px',
          display: 'inline-block'
        }}
        onClick={() => setViewingAlmacen(!viewingAlmacen)}
      >
        {viewingAlmacen ? 'Ver Cajas' : 'Ver Almacén'}
      </button>
    )}

    
{((isAlmacen && !isAlmacen2) || ((isGerente || isAsesorTele) && viewingAlmacen)) && (
      <button
        style={{
          ...styles.button,
          backgroundColor: onlyDomicilio ? '#9C27B0' : '#000000',
          maxWidth: '220px',
          display: 'inline-block'
        }}
        onClick={() => setOnlyDomicilio(v => !v)}
        title={
          onlyDomicilio
            ? 'Mostrando Domicilio — clic para ver Foráneos'
            : 'Mostrando Foráneos — clic para ver Domicilio'
        }
      >
        {onlyDomicilio ? 'Ver Foráneos' : 'Ver Domicilio'}
      </button>
    )}
  </div>
)}

{visibleZone && (isCajera || ((isGerente || isAsesorTele) && !viewingAlmacen)) && (
  <div style={{ textAlign: 'center', margin: '6px 0 14px', fontSize: 18, fontWeight: 700 }}>
    {ZONES_META[visibleZone]?.cashier || 'Cajera'} · {ZONES_META[visibleZone]?.label || visibleZone}
  </div>
)}

{(isCajera || ((isGerente || isAsesorTele) && !viewingAlmacen)) && (
  <div style={{ width: '100%' }}>
    <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px', gap: '10px' }}>
      {visibleZones.map(({ zone, label, color, icon }) => {
        const data = orders?.[zone] || [];
        const isActive = activeZoneButton === zone;

        return (
          <button
            key={zone}
            onClick={() => {
              const next = activeZoneButton === zone ? null : zone;
              setActiveZoneButton(next);
              setVisibleZone(next);
            }}
            style={{
              flex: 1,
              padding: '10px',
              fontWeight: 'bold',
              backgroundColor: color,
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              opacity: activeZoneButton === null || isActive ? 1 : 0.5
            }}
          >
            {label} {icon} ({data.length})
          </button>
        );
      })}
    </div>

    {visibleZone && (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'flex-start' }}>
        {(orders?.[visibleZone] || [])
          .filter(order => (order.status || '').toLowerCase().trim() === 'aplicando pago')
          .filter(matchesSearch)
          .sort(compareByPendienteThenDate)
          .map((order, index) => renderWaitingCard(order, index))}
      </div>
    )}
  </div>
)}

{((isAlmacen && !isAlmacen2) || ((isGerente || isAsesorTele) && viewingAlmacen)) && (
  <div style={{ width: '100%' }}>

    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 10,
        marginBottom: 12,
        justifyContent: 'flex-start'
      }}
    >
      <button
        onClick={() => {
          setActiveCarrierButton(null);
          setVisibleCarrier(null);
        }}
        style={{
          ...styles.button,
          backgroundColor: activeCarrierButton === null ? '#455A64' : '#000000',
          maxWidth: '240px',
          marginLeft: 0,
          display: 'inline-block'
        }}
        title="Quitar filtro de paquetería"
      >
        Todas las paqueterías ({getCarrierCount(null)})
      </button>

      {carriersForAlmacen.map((carrier) => {
        const isActive = activeCarrierButton === carrier;
        const count = getCarrierCount(carrier);

        return (
          <button
            key={carrier}
            onClick={() => {
              const next = isActive ? null : carrier;
              setActiveCarrierButton(next);
              setVisibleCarrier(next);
            }}
            style={{
              ...styles.button,
              backgroundColor: isActive ? '#1E88E5' : '#000000',
              maxWidth: '240px',
              marginLeft: 0,
              display: 'inline-block'
            }}
            title={`Filtrar por: ${carrier}`}
          >
            {carrier} ({count})
          </button>
        );
      })}
    </div>

    <div style={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px', gap: '10px' }}>
      {(onlyDomicilio
        ? [
            { status: 'facturado',           label: 'Asignar Surtidor',    color: '#00897B', icon: '🧑‍🏭' },
            { status: 'surtiendo',           label: 'Surtiendo',           color: '#FFD700', icon: '🛠️' },
            { status: 'surtido-despachador', label: 'Asignar Despachador', color: '#8E24AA', icon: '🚚' },
            { status: 'empacando',           label: 'Empacado',            color: '#0288D1', icon: '📦' },
            { status: 'enviado',             label: 'Entregando',          color: '#F57C00', icon: '🚚' },
            { status: 'entregado',           label: 'Entregado',           color: '#616161', icon: '✅' }
          ]
        : [
            { status: 'facturado',           label: 'Asignar Surtidor',    color: '#00897B', icon: '🧑‍🏭' },
            { status: 'surtiendo',           label: 'Surtiendo',           color: '#FFD700', icon: '🛠️' },
            { status: 'surtido-despachador', label: 'Asignar Despachador', color: '#8E24AA', icon: '🚚' },
            { status: 'surtido',             label: 'Asignar Empacador',   color: '#9C27B0', icon: '🧑‍🔧' },
            { status: 'empacando',           label: 'Empacado',            color: '#0288D1', icon: '📦' },
            { status: 'enviado',             label: 'Entregando',          color: '#F57C00', icon: '🚚' },
            { status: 'entregado',           label: 'Entregado',           color: '#616161', icon: '✅' }
          ]
      ).map(({ status, label, color, icon }) => {
        const filtered = getOrdersForBucketCarrier(status);
        const isActive = activeStatusButton === status;

        return (
          <button
            key={status}
            onClick={() => {
              const next = activeStatusButton === status ? null : status;
              setActiveStatusButton(next);
              setVisibleStatus(next);
            }}
            style={{
              flex: 1,
              padding: '10px',
              fontWeight: 'bold',
              backgroundColor: color,
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              opacity: isActive || activeStatusButton === null ? 1 : 0.5
            }}
          >
            {label} {icon} ({filtered.length})
          </button>
        );
      })}
    </div>

    {visibleStatus && visibleStatus !== 'entregado' && (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'flex-start' }}>
        {(() => {
          const mapping = {
            facturado:              renderSurtidorCard,
            surtiendo:              renderSurtiendoCard,
            'surtido-despachador':  renderDespachadorCard,
            surtido:                renderEmpacandoCard,
            empacando:              renderEmpacandoAsignadoCard,
            enviado:                renderEnviadoCard,
            entregado:              () => null
          };
          const render = mapping[visibleStatus];

          return getOrdersForBucketCarrier(visibleStatus)
            .sort(compareByPendienteThenDate)
            .map((order, index) => render(order, index));
        })()}
      </div>
    )}

    {visibleStatus === 'entregado' && (
      <EntregadosColumn
        orders={getOrdersForBucketCarrier('entregado')}
        isDeliveredToday={isDeliveredToday}
        ymdTZ={ymdTZ}
        renderEntregadoCard={renderEntregadoCard}
      />
    )}
  </div>
)}

              {isAlmacen2 && (
                <div style={{ width: '100%', overflowX: 'hidden', overflowY: 'hidden' }}>
                  <style>{`
      .foraneos-marquee {
        position: relative;
        overflow: hidden;
        white-space: nowrap;
        height: 26px;
        display: flex;
        align-items: center;
      }
      .foraneos-marquee > span {
        display: inline-block;
        white-space: nowrap;
        padding-left: 100%;
        animation: foraneos-marquee-scroll 12s linear infinite;
      }
      .foraneos-marquee:hover > span { animation-play-state: paused; }
      @keyframes foraneos-marquee-scroll {
        0%   { transform: translateX(0); }
        100% { transform: translateX(-100%); }
      }
      .foraneos-num { font-variant-numeric: tabular-nums; font-feature-settings: "tnum"; }
      .foraneos-scroll { overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none; }
      .foraneos-scroll::-webkit-scrollbar { width: 0; height: 0; }
      .foraneos-scroll::-webkit-scrollbar-thumb,
      .foraneos-scroll::-webkit-scrollbar-track { background: transparent; }
    `}</style>

                  {(() => {
                    const FIXED = ['PMM','Flecha Amarilla', 'Inbox', 'Spatmail', 'Teammex', 'Saltillo', 'Domicilio'];
                    const norm = s => (s || '').toString().trim().toLowerCase();


                    const showDeliveredWithinOneHour = (o) => {
                      const st = String(o?.status || '').toLowerCase();
                      if (st !== 'entregado') return true; 
                      const ts = o?.delivered_at || o?.last_status_change_at || o?.updated_at;
                      if (!ts) return false;
                      const deliveredMs = new Date(ts).getTime();
                      const nowMs = (typeof nowTick === 'number') ? nowTick : Date.now();
                      return (nowMs - deliveredMs) <= ONE_HOUR_MS;
                    };
                    const isPorSurtir = (o) => {
                      const noSurtidor = !(o?.surtidor_id) && !(o?.surtidor_name);
                      const st = String(o?.status || '').toLowerCase();
                      const valido = st !== 'cancelado' && st !== 'entregado';
                      return noSurtidor && valido;
                    };

                    const dynamic = Array.from(
                      new Set((orders || []).map(o => o?.carrier?.toString().trim()).filter(Boolean))
                    )
                      .filter(name => !FIXED.some(f => norm(f) === norm(name)))
                      .filter(name => {
                        const list = (orders || []).filter(o => norm(o.carrier) === norm(name));
                        const visibles = list
                          .filter(o => !isPorSurtir(o))
                          .filter(showDeliveredWithinOneHour);                        return visibles.length > 0;
                      });

                    const extra = dynamic.slice(0, Math.max(0, 11 - FIXED.length));
                    const DISPLAY = [...FIXED, ...extra];

                    const H = (typeof window !== 'undefined' ? window.innerHeight : 1080) || 1080;
                    const listHeightPx = Math.max(320, Math.floor(H - 135));

                    const formatFull = (ms) => {
                      if (ms == null || isNaN(ms)) return '—';
                      const totalMin = Math.floor(Math.max(0, ms) / 60000);
                      const d = Math.floor(totalMin / (60 * 24));
                      const h = Math.floor((totalMin % (60 * 24)) / 60);
                      const m = totalMin % 60;
                      if (d > 0) return `${d}d ${h}h ${m}m`;
                      if (h > 0) return `${h}h ${m}m`;
                      return `${m}m`;
                    };

                    const getTimers = (order) => {
                      const nowMs = (typeof nowTick === 'number') ? nowTick : Date.now();
                      const startTotal  = order?.created_at ? new Date(order.created_at).getTime() : null;
                      const startStatus = order?.last_status_change_at ? new Date(order.last_status_change_at).getTime() : null;
                      const end = order?.delivered_at ? new Date(order.delivered_at).getTime() : nowMs;
                      return {
                        totalMs:  (startTotal  != null) ? (end - startTotal)  : null,
                        statusMs: (startStatus != null) ? (end - startStatus) : null,
                      };
                    };

                    return (
                      <div
                        style={{
                          display: 'grid',
                          gridTemplateColumns: `repeat(${DISPLAY.length}, 1fr)`,
                          columnGap: 6,
                          padding: '8px 10px',
                          alignItems: 'start',
                          width: '100%',
                        }}
                      >
                        {DISPLAY.map((carrier) => {
                          const byCarrier = (orders || []).filter(o => norm(o.carrier) === norm(carrier));

                          const porSurtirCount = byCarrier.filter(isPorSurtir).length;

                          const ordered = [...byCarrier].sort((a, b) => {
                            const aKey = isPorSurtir(a) ? 0 : 1;
                            const bKey = isPorSurtir(b) ? 0 : 1;
                            if (aKey !== bKey) return aKey - bKey;
                            return new Date(a.created_at) - new Date(b.created_at);
                          });

                          const visibles = ordered
                          .filter(o => !isPorSurtir(o))
                          .filter(showDeliveredWithinOneHour);
                        
                          const totalVisibles = visibles.length;

                          return (
                            <div key={carrier} style={{ width: '100%' }}>
                              <div
                                style={{
                                  background: 'linear-gradient(180deg, #3a3a3a 0%, #2f2f2f 100%)',
                                  color: '#fff',
                                  padding: '10px 8px 9px',
                                  borderRadius: '8px',
                                  textAlign: 'center',
                                  marginBottom: '8px',
                                  lineHeight: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  gap: 6
                                }}
                              >
                                <div style={{ fontSize: 'clamp(13px, 1.05vw, 16px)', fontWeight: 900 }}>
                                  {carrier}
                                </div>
                                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                  <div
                                    style={{
                                      backgroundColor: '#7B1E3B',
                                      color: '#fff',
                                      borderRadius: '6px',
                                      padding: '5px 12px',
                                      fontSize: 'clamp(12px, 1.05vw, 15px)',
                                      fontWeight: 900,
                                      lineHeight: 1
                                    }}
                                    title="Pedidos sin surtidor asignado"
                                  >
                                    EN FILA ({porSurtirCount})
                                  </div>
                                  <div
                                    style={{
                                      backgroundColor: '#616161',
                                      color: '#fff',
                                      borderRadius: '6px',
                                      padding: '5px 12px',
                                      fontSize: 'clamp(12px, 1.05vw, 15px)',
                                      fontWeight: 900,
                                      lineHeight: 1
                                    }}
                                    title="Pedidos mostrados en esta columna"
                                  >
                                    TOTAL ({totalVisibles})
                                  </div>
                                </div>
                              </div>

                              {visibles.length > 0 ? (
                                visibles.length > 6 ? (
                                  <AutoPaginator
                                    items={visibles}
                                    pageSize={6}
                                    interval={6000}
                                    renderItem={(order) => {
                                      const { totalMs, statusMs } = getTimers(order);
                                      const statusText  = getStatusLabel(order.status);
                                      const statusStyle = getStatusStyle(order.status);
                                      const late = isPendingOverDay(order, nowTick);
                                      const borderColor = late ? '#E53935' : (statusStyle?.backgroundColor || '#BDBDBD');

                                      return (
                                        <div
                                          style={{
                                            position: 'relative',
                                            backgroundColor: '#fefefe',
                                            padding: '46px 8px 8px',
                                            borderRadius: '10px',
                                            marginBottom: '6px',
                                            border: `2px solid ${borderColor}`,
                                            boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                                            fontSize: 'clamp(11px, 0.9vw, 13px)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            minHeight: 100
                                          }}
                                        >
                                          <div
                                            style={{
                                              position: 'absolute',
                                              top: 6,
                                              left: 8,
                                              background: '#ECEFF1',
                                              color: '#263238',
                                              border: '1px solid #CFD8DC',
                                              borderRadius: 6,
                                              padding: '3px 6px',
                                              fontWeight: 800,
                                              fontSize: 'clamp(12px, 1vw, 15px)',
                                              lineHeight: 1,
                                              height: 22,
                                              display: 'flex',
                                              alignItems: 'center',
                                              maxWidth: '56%',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap'
                                            }}
                                            title={`Pedido: ${order.erp_order_id}`}
                                          >
                                            {order.erp_order_id}
                                          </div>
                                          {late && (
                                            <div
                                              style={pendingPillStyle}
                                              className="pendiente-blink"
                                              title="Pendiente por más de 1 día">
                                              <span
                                                style={{
                                                  display: 'inline-block',
                                                  width: 8,
                                                  height: 8,
                                                  borderRadius: '50%',
                                                  background: '#E53935'
                                                }}
                                              />
                                              PENDIENTE
                                            </div>
                                          )}
                                          <div
                                            style={{
                                              position: 'absolute',
                                              top: 6,
                                              right: 8,
                                              borderRadius: 6,
                                              fontWeight: 'bold',
                                              fontSize: 'clamp(10px, 0.85vw, 12px)',
                                              lineHeight: 1,
                                              maxWidth: '42%',
                                              height: 22,
                                              display: 'flex',
                                              alignItems: 'center',
                                              overflow: 'hidden',
                                              ...statusStyle
                                            }}
                                            title={statusText}
                                          >
                                            <div className="foraneos-marquee" style={{ padding: '0 6px', borderRadius: 6, width: '100%' }}>
                                              <span>{statusText} &nbsp;•&nbsp; {statusText}</span>
                                            </div>
                                          </div>
                                          <div
                                            className="foraneos-num"
                                            style={{
                                              display: 'grid',
                                              gridTemplateColumns: '1fr 1fr',
                                              columnGap: 10,
                                              alignItems: 'start',
                                              marginTop: 0,
                                              paddingBottom: 4,
                                              borderBottom: '1px solid #E0E0E0'
                                            }}
                                          >
                                            <div style={{ textAlign: 'left' }}>
                                              <div style={{ opacity: .75, fontWeight: 600, fontSize: 'clamp(10px, .85vw, 12px)', marginBottom: 2 }}>
                                                Total
                                              </div>
                                              <div style={{ fontWeight: 800, fontSize: 'clamp(11px, .95vw, 14px)' }}>
                                                {formatFull(totalMs)}
                                              </div>
                                            </div>

                                            <div style={{ textAlign: 'right' }}>
                                              <div style={{ opacity: .75, fontWeight: 600, fontSize: 'clamp(10px, .85vw, 12px)', marginBottom: 2 }}>
                                                Estatus
                                              </div>
                                              <div style={{ fontWeight: 800, fontSize: 'clamp(11px, .95vw, 14px)' }}>
                                                {formatFull(statusMs)}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              fontSize: 'clamp(13px, 1.05vw, 16px)',
                                              fontWeight: 800,
                                              display: '-webkit-box',
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: 'vertical',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              lineHeight: 1.15,
                                              minHeight: '2.2em',
                                              marginTop: 6
                                            }}
                                            title={order.customer_name || ''}
                                          >
                                            {order.customer_name}
                                          </div>
                                        </div>
                                      );
                                    }}
                                  />
                                ) : (
                                  <div style={{ maxHeight: listHeightPx, overflowY: 'auto', paddingRight: 10 }}>
                                    {visibles.map((order, index) => {
                                      const { totalMs, statusMs } = getTimers(order);
                                      const statusText  = getStatusLabel(order.status);
                                      const statusStyle = getStatusStyle(order.status);
                                      const late = isPendingOverDay(order, nowTick);
                                      const borderColor = late ? '#E53935' : (statusStyle?.backgroundColor || '#BDBDBD');

                                      return (
                                        <div
                                          key={index}
                                          style={{
                                            position: 'relative',
                                            backgroundColor: '#fefefe',
                                            padding: '46px 8px 8px',
                                            borderRadius: '10px',
                                            marginBottom: '6px',
                                            border: `2px solid ${borderColor}`,
                                            boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                                            fontSize: 'clamp(11px, 0.9vw, 13px)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            minHeight: 100
                                          }}
                                        >
                                          <div
                                            style={{
                                              position: 'absolute',
                                              top: 6,
                                              left: 8,
                                              background: '#ECEFF1',
                                              color: '#263238',
                                              border: '1px solid #CFD8DC',
                                              borderRadius: 6,
                                              padding: '3px 6px',
                                              fontWeight: 800,
                                              fontSize: 'clamp(12px, 1vw, 15px)',
                                              lineHeight: 1,
                                              height: 22,
                                              display: 'flex',
                                              alignItems: 'center',
                                              maxWidth: '56%',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              whiteSpace: 'nowrap'
                                            }}
                                            title={`Pedido: ${order.erp_order_id}`}
                                          >
                                            {order.erp_order_id}
                                          </div>

                                          {late && (
                                            <div
                                              style={pendingPillStyle}
                                              className="pendiente-blink"
                                              title="Pendiente por más de 1 día"
                                            >
                                              <span
                                                style={{
                                                  display: 'inline-block',
                                                  width: 8,
                                                  height: 8,
                                                  borderRadius: '50%',
                                                  background: '#E53935'
                                                }}
                                              />
                                              PENDIENTE
                                            </div>
                                          )}
                                          <div
                                            style={{
                                              position: 'absolute',
                                              top: 6,
                                              right: 8,
                                              borderRadius: 6,
                                              fontWeight: 'bold',
                                              fontSize: 'clamp(10px, 0.85vw, 12px)',
                                              lineHeight: 1,
                                              maxWidth: '42%',
                                              height: 22,
                                              display: 'flex',
                                              alignItems: 'center',
                                              overflow: 'hidden',
                                              ...statusStyle
                                            }}
                                            title={statusText}
                                          >
                                            <div className="foraneos-marquee" style={{ padding: '0 6px', borderRadius: 6, width: '100%' }}>
                                              <span>{statusText} &nbsp;•&nbsp; {statusText}</span>
                                            </div>
                                          </div>
                                          <div
                                            className="foraneos-num"
                                            style={{
                                              display: 'grid',
                                              gridTemplateColumns: '1fr 1fr',
                                              columnGap: 10,
                                              alignItems: 'start',
                                              marginTop: 0,
                                              paddingBottom: 4,
                                              borderBottom: '1px solid #E0E0E0'
                                            }}
                                          >
                                            <div style={{ textAlign: 'left' }}>
                                              <div style={{ opacity: .75, fontWeight: 600, fontSize: 'clamp(10px, .85vw, 12px)', marginBottom: 2 }}>Total</div>
                                              <div style={{ fontWeight: 800, fontSize: 'clamp(11px, .95vw, 14px)' }}>{formatFull(totalMs)}</div>
                                            </div>
                                            <div style={{ textAlign: 'right' }}>
                                              <div style={{ opacity: .75, fontWeight: 600, fontSize: 'clamp(10px, .85vw, 12px)', marginBottom: 2 }}>Estatus</div>
                                              <div style={{ fontWeight: 800, fontSize: 'clamp(11px, .95vw, 14px)' }}>{formatFull(statusMs)}</div>
                                            </div>
                                          </div>

                                          {/* CLIENTE */}
                                          <div
                                            style={{
                                              fontSize: 'clamp(13px, 1.05vw, 16px)',
                                              fontWeight: 800,
                                              display: '-webkit-box',
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: 'vertical',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                              lineHeight: 1.15,
                                              minHeight: '2.2em',
                                              marginTop: 6
                                            }}
                                            title={order.customer_name || ''}
                                          >
                                            {order.customer_name}
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                )
                              ) : (
                                <p style={{ fontStyle: 'italic', color: '#aaa', fontSize: '10px', margin: 0 }}>Sin turnos</p>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    );
                  })()}
                </div>
              )}
            </div>
          </div>
        ),
        document.body
      )}

<Modalforaneosprint
  open={printOpen}
  data={printData}
  onClose={() => { setPrintOpen(false); setPrintData(null); }}
/>
    </>
  );
};

export default ModalForaneos;
